var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eCqFtfLiQTu1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 350",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "1f8b637a7bd9492e8e1384c6fe92650b",
    "export-id": "b14c89b6d48342429b5a566986df684d",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu6-fill",
    x1: 1428.81,
    y1: 1132.12,
    x2: 2249.228,
    y2: 200.549,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu6-fill-0",
    offset: "0%",
    stopColor: "#eee6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu6-fill-1",
    offset: "100%",
    stopColor: "#d4c3d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu8-fill",
    x1: 1678.15,
    y1: 2240.16,
    x2: 1834.867,
    y2: 1241.084,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu8-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu8-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu9-fill",
    x1: 2307.61,
    y1: 1963.48,
    x2: 1620.617,
    y2: 895.42,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu9-fill-0",
    offset: "0.5%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu9-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu12-fill",
    x1: 291.359922,
    y1: 248.3,
    x2: 299.689922,
    y2: 217.36,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu12-fill-0",
    offset: "2%",
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu12-fill-1",
    offset: "55%",
    stopColor: "#e4e4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu12-fill-2",
    offset: "99%",
    stopColor: "#9a9a9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu13-fill",
    x1: 292.649922,
    y1: 240.84,
    x2: 271.189922,
    y2: 309.15,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu13-fill-0",
    offset: "0%",
    stopColor: "#d0d0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu13-fill-1",
    offset: "14%",
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu13-fill-2",
    offset: "66%",
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu13-fill-3",
    offset: "85%",
    stopColor: "#9d9d9e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu13-fill-4",
    offset: "100%",
    stopColor: "#b7b7ba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu14-fill",
    x1: 280.269922,
    y1: 215.28,
    x2: 243.149922,
    y2: 308.65,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu14-fill-0",
    offset: "0%",
    stopColor: "#6e737a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu14-fill-1",
    offset: "79%",
    stopColor: "#484b4e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu14-fill-2",
    offset: "100%",
    stopColor: "#55585e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu15-fill",
    x1: 283.759922,
    y1: 252.5,
    x2: 259.599922,
    y2: 328.37,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu15-fill-0",
    offset: "0%",
    stopColor: "#d0d0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu15-fill-1",
    offset: "19%",
    stopColor: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu15-fill-2",
    offset: "44%",
    stopColor: "#959596"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu15-fill-3",
    offset: "81%",
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu15-fill-4",
    offset: "100%",
    stopColor: "#9a9a9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu16-fill",
    x1: 108.9,
    y1: 248.3,
    x2: 100.57,
    y2: 217.36,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu16-fill-0",
    offset: "2%",
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu16-fill-1",
    offset: "55%",
    stopColor: "#e4e4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu16-fill-2",
    offset: "99%",
    stopColor: "#9a9a9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu17-fill",
    x1: 107.61,
    y1: 240.84,
    x2: 129.08,
    y2: 309.15,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu17-fill-0",
    offset: "0%",
    stopColor: "#d0d0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu17-fill-1",
    offset: "14%",
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu17-fill-2",
    offset: "66%",
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu17-fill-3",
    offset: "85%",
    stopColor: "#9d9d9e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu17-fill-4",
    offset: "100%",
    stopColor: "#b7b7ba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu18-fill",
    x1: 119.99,
    y1: 215.28,
    x2: 157.11,
    y2: 308.65,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu18-fill-0",
    offset: "0%",
    stopColor: "#6e737a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu18-fill-1",
    offset: "79%",
    stopColor: "#484b4e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu18-fill-2",
    offset: "100%",
    stopColor: "#55585e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu19-fill",
    x1: 116.51,
    y1: 252.5,
    x2: 140.66,
    y2: 328.37,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu19-fill-0",
    offset: "0%",
    stopColor: "#d0d0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu19-fill-1",
    offset: "19%",
    stopColor: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu19-fill-2",
    offset: "44%",
    stopColor: "#959596"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu19-fill-3",
    offset: "81%",
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu19-fill-4",
    offset: "100%",
    stopColor: "#9a9a9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu20-fill",
    x1: 204.27,
    y1: 245.03,
    x2: 185.18,
    y2: 80.93,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu20-fill-0",
    offset: "2%",
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu20-fill-1",
    offset: "9%",
    stopColor: "#e4e4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu20-fill-2",
    offset: "90%",
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu20-fill-3",
    offset: "99%",
    stopColor: "#e4e4e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu21-fill",
    x1: 200.01,
    y1: 94.08,
    x2: 200.19,
    y2: 150.28,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu21-fill-0",
    offset: "2%",
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu21-fill-1",
    offset: "20%",
    stopColor: "#e4e4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu21-fill-2",
    offset: "99%",
    stopColor: "#d4d4d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu23-fill",
    x1: 112.39,
    y1: 117.55,
    x2: 121.56,
    y2: 144.8,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu23-fill-0",
    offset: "0%",
    stopColor: "#d0d0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu23-fill-1",
    offset: "62%",
    stopColor: "#acacad"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu23-fill-2",
    offset: "100%",
    stopColor: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu24-fill",
    x1: 279.53,
    y1: 113.4,
    x2: 290.4,
    y2: 145.7,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu24-fill-0",
    offset: "0%",
    stopColor: "#d0d0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu24-fill-1",
    offset: "62%",
    stopColor: "#acacad"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu24-fill-2",
    offset: "100%",
    stopColor: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu25-fill",
    x1: 201.68,
    y1: 143.05,
    x2: 199.68,
    y2: 271.05,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu25-fill-0",
    offset: "4%",
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu25-fill-1",
    offset: "18%",
    stopColor: "#e4e4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu25-fill-2",
    offset: "99%",
    stopColor: "#d4d4d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu26-fill",
    x1: 182.5,
    y1: 133.25,
    x2: 226.2,
    y2: 263.17,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu26-fill-0",
    offset: "0%",
    stopColor: "#d0d0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu26-fill-1",
    offset: "62%",
    stopColor: "#acacad"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu26-fill-2",
    offset: "100%",
    stopColor: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu27-fill",
    x1: 105.84,
    y1: 156.5,
    x2: 134.16,
    y2: 201.15,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu27-fill-0",
    offset: "0%",
    stopColor: "#56595e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu27-fill-1",
    offset: "100%",
    stopColor: "#393b3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu28-fill",
    x1: 108.37,
    y1: 160.48,
    x2: 131.14,
    y2: 196.39,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu28-fill-0",
    offset: "0%",
    stopColor: "#56595e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu28-fill-1",
    offset: "100%",
    stopColor: "#393b3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu29-fill",
    x1: -17.74,
    y1: -27.98,
    x2: 21.26,
    y2: 33.52,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu29-fill-0",
    offset: "0%",
    stopColor: "#6e7178"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu29-fill-1",
    offset: "100%",
    stopColor: "#515457"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu30-fill",
    x1: -11.26,
    y1: -17.76,
    x2: 13.49,
    y2: 21.27,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu30-fill-0",
    offset: "0%",
    stopColor: "#56595e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu30-fill-1",
    offset: "100%",
    stopColor: "#393b3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu31-fill",
    x1: -17.75,
    y1: -27.98,
    x2: 21.26,
    y2: 33.52,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu31-fill-0",
    offset: "0%",
    stopColor: "#6e7178"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu31-fill-1",
    offset: "100%",
    stopColor: "#515457"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu32-fill",
    x1: -11.26,
    y1: -17.76,
    x2: 13.49,
    y2: 21.27,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu32-fill-0",
    offset: "0%",
    stopColor: "#56595e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu32-fill-1",
    offset: "100%",
    stopColor: "#393b3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu33-fill",
    x1: 9.48,
    y1: 17.27,
    x2: -6.02,
    y2: -10.98,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu33-fill-0",
    offset: "0%",
    stopColor: "#d97c1e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu33-fill-1",
    offset: "100%",
    stopColor: "#f2b613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu34-fill",
    x1: -5.27,
    y1: -11.98,
    x2: 6.73,
    y2: 15.27,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu34-fill-0",
    offset: "0%",
    stopColor: "#53ab6c"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu34-fill-1",
    offset: "100%",
    stopColor: "#35993a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu35-fill",
    x1: 9.47,
    y1: 17.26,
    x2: -6.03,
    y2: -10.99,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu35-fill-0",
    offset: "0%",
    stopColor: "#32548c"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu35-fill-1",
    offset: "100%",
    stopColor: "#376ab8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu36-fill",
    x1: -5.16,
    y1: -12.81,
    x2: 5.17,
    y2: 12.86,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu36-fill-0",
    offset: "0%",
    stopColor: "#f36468"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu36-fill-1",
    offset: "100%",
    stopColor: "#b5181d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu37-fill",
    x1: 68.18,
    y1: 205.88,
    x2: 105.18,
    y2: 315.88,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu37-fill-0",
    offset: "0%",
    stopColor: "#d0d0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu37-fill-1",
    offset: "62%",
    stopColor: "#acacad"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu37-fill-2",
    offset: "100%",
    stopColor: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu38-fill",
    x1: 308.97,
    y1: 210.61,
    x2: 343.59,
    y2: 313.52,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu38-fill-0",
    offset: "0%",
    stopColor: "#d0d0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu38-fill-1",
    offset: "62%",
    stopColor: "#acacad"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu38-fill-2",
    offset: "100%",
    stopColor: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu40-fill",
    x1: 2322.41,
    y1: 753.402,
    x2: 2290.222,
    y2: 690.857,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu40-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu40-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu41-fill",
    x1: 2190.73,
    y1: 752.45,
    x2: 2285.498,
    y2: 752.45,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu41-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu41-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu42-fill",
    x1: 2266.01,
    y1: 685.323,
    x2: 2353.21,
    y2: 823.61,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu42-fill-0",
    offset: "32.5%",
    stopColor: "#d15050"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu42-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu43-fill",
    x1: 2389.88,
    y1: 721.522,
    x2: 2279.189,
    y2: 905.269,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu43-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu43-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu45-fill",
    x1: 2026.07,
    y1: 753.807,
    x2: 2158.216,
    y2: 580.481,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu45-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu45-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu47-fill",
    x1: 2285.61,
    y1: 774.094,
    x2: 2248.272,
    y2: 723.555,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu47-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu47-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu50-fill",
    x1: 2217.46,
    y1: 764.9,
    x2: 2186.695,
    y2: 723.259,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu50-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu50-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu53-fill",
    x1: 2223.54,
    y1: 815.36,
    x2: 2190.361,
    y2: 770.397,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu53-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu53-fill-1",
    offset: "85.6%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu54-fill",
    x1: 2328.08,
    y1: 723.517,
    x2: 2303.982,
    y2: 670.247,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu54-fill-0",
    offset: "12.8%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu54-fill-1",
    offset: "52.9%",
    stopColor: "#ed956e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu56-fill",
    x1: 2127.53,
    y1: 710.4,
    x2: 2189.449,
    y2: 761.937,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu56-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu56-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu57-fill",
    x1: 2200.55,
    y1: 705.362,
    x2: 2234.712,
    y2: 731.602,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu57-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu57-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu68-fill",
    x1: 2021.92,
    y1: 1075.03,
    x2: 2080.785,
    y2: 1075.03,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu68-fill-0",
    offset: "12.6%",
    stopColor: "#056657"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu68-fill-1",
    offset: "100%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu69-fill",
    x1: 2077.17,
    y1: 1080.17,
    x2: 1975.714,
    y2: 1073.051,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu69-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu69-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu70-fill",
    x1: 1886.69,
    y1: 1021.9,
    x2: 2109.957,
    y2: 1230.918,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu70-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu70-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu71-fill",
    x1: 2485.52,
    y1: 1591.75,
    x2: 1951.087,
    y2: 1010.162,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu71-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu71-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu72-fill",
    x1: 2117.06,
    y1: 1243.71,
    x2: 2036.205,
    y2: 903.267,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu72-fill-0",
    offset: "17.4%",
    stopColor: "#a58ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu72-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu72-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu73-fill",
    x1: 2284.18,
    y1: 1360.75,
    x2: 1707.596,
    y2: 710.066,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu73-fill-0",
    offset: "17.4%",
    stopColor: "#a58ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu73-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu73-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu74-fill",
    x1: 2231.91,
    y1: 869.237,
    x2: 2426.12,
    y2: 860.986,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu74-fill-0",
    offset: "17.4%",
    stopColor: "#a58ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu74-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu74-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu75-fill",
    x1: 1851.65,
    y1: 1328.51,
    x2: 1770.628,
    y2: 987.366,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu75-fill-0",
    offset: "17.4%",
    stopColor: "#a58ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu75-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu75-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu77-fill",
    x1: 1881.5,
    y1: 1041.11,
    x2: 1966.304,
    y2: 1136.314,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu77-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu77-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu78-fill",
    x1: 2211.43,
    y1: 729.696,
    x2: 2229.447,
    y2: 751.987,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu78-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu78-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu81-fill",
    x1: 2214.85,
    y1: 792.372,
    x2: 2224.097,
    y2: 798.653,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu81-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu81-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu89-fill",
    x1: 2150.95,
    y1: 738.403,
    x2: 2166.098,
    y2: 757.184,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu89-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu89-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu95-fill",
    x1: 2131.91,
    y1: 790.031,
    x2: 2316.61,
    y2: 989.942,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu95-fill-0",
    offset: "15.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu95-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu96-fill",
    x1: 2177.92,
    y1: 871.594,
    x2: 2242.003,
    y2: 930.271,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu96-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu96-fill-1",
    offset: "92.1%",
    stopColor: "#f05960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu97-fill",
    x1: 2345.35,
    y1: 736.895,
    x2: 2247.815,
    y2: 906.382,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu97-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu97-fill-1",
    offset: "100%",
    stopColor: "#a31d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu98-fill",
    x1: 2308.43,
    y1: 736.744,
    x2: 2273.196,
    y2: 708.92,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu98-fill-0",
    offset: "1.9%",
    stopColor: "#d65764"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu98-fill-1",
    offset: "63%",
    stopColor: "#ffc6a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu101-fill",
    x1: 2224.75,
    y1: 622.115,
    x2: 2156.996,
    y2: 629.124,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu101-fill-0",
    offset: "5.6%",
    stopColor: "#ffddc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu101-fill-1",
    offset: "77.1%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu103-fill",
    x1: 1771.34,
    y1: 1412.46,
    x2: 1830.997,
    y2: 1412.46,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu103-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu103-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu105-fill",
    x1: 1803.98,
    y1: 1470.76,
    x2: 1724.469,
    y2: 1405.973,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu105-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu105-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu107-fill",
    x1: 1679.02,
    y1: 667.693,
    x2: 2165.941,
    y2: 1149.264,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu107-fill-0",
    offset: "21.6%",
    stopColor: "#ffb3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu107-fill-1",
    offset: "85.2%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu108-fill",
    x1: 2145.55,
    y1: 1498.03,
    x2: 1654.579,
    y2: 1374.396,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu108-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu108-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu108-fill-2",
    offset: "81%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu108-fill-3",
    offset: "100%",
    stopColor: "#f15e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu109-fill",
    x1: 1765.2,
    y1: 1375.21,
    x2: 1793.939,
    y2: 1475.643,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu109-fill-0",
    offset: "25.5%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu109-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu110-fill",
    x1: 1748.11,
    y1: 1374.96,
    x2: 1825.142,
    y2: 1374.96,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu110-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu110-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu111-fill",
    x1: 1775.22,
    y1: 1460.09,
    x2: 1737.006,
    y2: 1379.218,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu111-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu111-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu112-fill",
    x1: 1738.88,
    y1: 1267.6,
    x2: 1781.849,
    y2: 1406.39,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu112-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu112-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu113-fill",
    x1: 1755.33,
    y1: 1490.37,
    x2: 1630.485,
    y2: 1342.541,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu113-fill-0",
    offset: "0.5%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu113-fill-1",
    offset: "30.2%",
    stopColor: "#dcd1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu113-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu114-fill",
    x1: 1315.47,
    y1: 478.64,
    x2: 2186.986,
    y2: 1176.936,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu114-fill-0",
    offset: "21.6%",
    stopColor: "#ffb3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu114-fill-1",
    offset: "85.2%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu115-fill",
    x1: 2397.07,
    y1: 1662.03,
    x2: 1519.908,
    y2: 1098.307,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu115-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu115-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu115-fill-2",
    offset: "81%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu115-fill-3",
    offset: "100%",
    stopColor: "#f15e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu116-fill",
    x1: 2300.17,
    y1: 1184.5,
    x2: 1973.456,
    y2: 1075.158,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu116-fill-0",
    offset: "17.4%",
    stopColor: "#a58ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu116-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu116-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu118-fill",
    x1: 1861.06,
    y1: 1110.85,
    x2: 2254.175,
    y2: 1110.85,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu118-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu118-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu119-fill",
    x1: 1861.06,
    y1: 1093.4,
    x2: 2254.175,
    y2: 1093.4,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu119-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu119-fill-1",
    offset: "99.9%",
    stopColor: "#d85335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu120-fill",
    x1: 2103.55,
    y1: 1095.53,
    x2: 2368.781,
    y2: 1095.53,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu120-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu120-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu121-fill",
    x1: 2103.55,
    y1: 1113.02,
    x2: 2368.781,
    y2: 1113.02,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu121-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu121-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu122-fill",
    x1: 1825.54,
    y1: 1540.66,
    x2: 1736.453,
    y2: 1427.074,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu122-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu122-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu123-fill",
    x1: 1768.77,
    y1: 1463.07,
    x2: 1703.166,
    y2: 1394.049,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu123-fill-0",
    offset: "0.5%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu123-fill-1",
    offset: "30.2%",
    stopColor: "#dcd1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu123-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu124-fill",
    x1: 1752.8,
    y1: 1462.3,
    x2: 1711.152,
    y2: 1380.316,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu124-fill-0",
    offset: "0.5%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu124-fill-1",
    offset: "30.2%",
    stopColor: "#dcd1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu124-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu132-fill",
    x1: 2261.22,
    y1: 766.713,
    x2: 1978.204,
    y2: 1434.206,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu132-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu132-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu133-fill",
    x1: 1917.09,
    y1: 797.807,
    x2: 2103.16,
    y2: 1013.781,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu133-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu133-fill-1",
    offset: "99.9%",
    stopColor: "#d85335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu134-fill",
    x1: 1714.92,
    y1: 1054.33,
    x2: 2108.738,
    y2: 838.286,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu134-fill-0",
    offset: "0%",
    stopColor: "#faa24b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu134-fill-1",
    offset: "100%",
    stopColor: "#ffce94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu135-fill",
    x1: 1755.47,
    y1: 1483.56,
    x2: 1624.143,
    y2: 1052.24,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu135-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu135-fill-1",
    offset: "63.7%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu135-fill-2",
    offset: "94.4%",
    stopColor: "#c93d47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu136-fill",
    x1: 1941.75,
    y1: 1076.5,
    x2: 1900.363,
    y2: 1055.807,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu136-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu136-fill-1",
    offset: "99.9%",
    stopColor: "#d85335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu142-fill",
    x1: 2342.92,
    y1: 641.972,
    x2: 2515.124,
    y2: 641.972,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu142-fill-0",
    offset: "0%",
    stopColor: "#eee6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu142-fill-1",
    offset: "100%",
    stopColor: "#d4c3d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu143-fill",
    x1: 2342.92,
    y1: 622.428,
    x2: 2515.124,
    y2: 622.428,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu143-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu143-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu151-fill",
    x1: 2556.87,
    y1: 626.434,
    x2: 2725.701,
    y2: 626.434,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu151-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu151-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu168-fill",
    x1: 2555.18,
    y1: 847.03,
    x2: 2727.384,
    y2: 847.03,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu168-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu168-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu186-fill",
    x1: 2583.11,
    y1: 1423.27,
    x2: 2519.312,
    y2: 1497.293,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu186-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu186-fill-1",
    offset: "62.8%",
    stopColor: "#d85335"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu186-fill-2",
    offset: "97.1%",
    stopColor: "#951a2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu190-fill",
    x1: 2423.38,
    y1: 1445.46,
    x2: 2503.383,
    y2: 1445.46,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu190-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu190-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu191-fill",
    x1: 2433.97,
    y1: 1445.48,
    x2: 2503.347,
    y2: 1445.48,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu191-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu191-fill-1",
    offset: "99.9%",
    stopColor: "#d85335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu192-fill",
    x1: 2443.55,
    y1: 1414.66,
    x2: 2468.598,
    y2: 1466.472,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu192-fill-0",
    offset: "0.5%",
    stopColor: "#faa24b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu192-fill-1",
    offset: "3.5%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu192-fill-2",
    offset: "100%",
    stopColor: "#ffce94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu240-fill",
    x1: 280.369774,
    y1: 9.055562,
    x2: 82.153601,
    y2: 414.142895,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu240-fill-0",
    offset: "1%",
    stopColor: "#9fa3ad"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu240-fill-1",
    offset: "52%",
    stopColor: "#70747a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu240-fill-2",
    offset: "84%",
    stopColor: "#4c4f54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu241-fill",
    x1: 153.62,
    y1: 334.21,
    x2: 97.62,
    y2: 192.54,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu241-fill-0",
    offset: "17%",
    stopColor: "#faa096"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu241-fill-1",
    offset: "56%",
    stopColor: "#ffaca3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu241-fill-2",
    offset: "100%",
    stopColor: "#ffbfa8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu242-fill",
    x1: 290.283411,
    y1: 37.566108,
    x2: 140.730327,
    y2: 350.856838,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu242-fill-0",
    offset: "17%",
    stopColor: "#ffe6d3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu242-fill-1",
    offset: "59%",
    stopColor: "#ffe6d3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu242-fill-2",
    offset: "100%",
    stopColor: "#f2dacb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu252-fill",
    x1: -4.450003,
    y1: -16.769998,
    x2: -12.280003,
    y2: -33.769998,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu252-fill-0",
    offset: "52%",
    stopColor: "#70747a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu252-fill-1",
    offset: "84%",
    stopColor: "#4c4f54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu253-fill",
    x1: -6.950002,
    y1: -22.2,
    x2: -14.780002,
    y2: -39.2,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu253-fill-0",
    offset: "52%",
    stopColor: "#70747a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu253-fill-1",
    offset: "84%",
    stopColor: "#4c4f54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu254-fill",
    x1: -9.370002,
    y1: -27.430001,
    x2: -17.200002,
    y2: -44.430001,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu254-fill-0",
    offset: "52%",
    stopColor: "#70747a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu254-fill-1",
    offset: "84%",
    stopColor: "#4c4f54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCqFtfLiQTu255-fill",
    x1: -11.82,
    y1: -32.760003,
    x2: -19.65,
    y2: -49.760003,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu255-fill-0",
    offset: "52%",
    stopColor: "#70747a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCqFtfLiQTu255-fill-1",
    offset: "84%",
    stopColor: "#4c4f54"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.163579 0 0 0.162436-103.861078-8.190701)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.923783 0 0 1.86382-2299.236304-861.939238)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2720,1119c-4.2-47.3-17.2-91.2-40.1-128.5-23-37.2-56-67.7-100.3-88.1-21.8-10-45.5-17.5-69.3-24.5-23.9-7-47.9-13.4-70.7-21.4-22.3-7.8-47.4-15.1-71.5-24.2-24.1-9.2-47.2-20.2-65.6-35.3-24.4-20.1-40.9-46.6-57.4-72.9-16.4-26.2-32.9-52.3-57.2-71.5-31.6-25-71.3-36-111.7-36.6-40.5-.7-81.7,9-116.4,25.4-12.8,6.1-25.1,13.4-36.6,21.7-11.6,8.3-22.5,17.6-32.7,27.8-20.9,20.7-38.8,44.8-53.4,70.5-14.6,25.8-25.9,53.2-33.6,80.5-19.2,68.2-20.8,145.5-6.8,219.8s43.6,145.5,86.9,201.5c57.5,74.2,139,125.3,228.6,154.6c89.7,29.3,187.5,36.9,277.6,24.3c41.4-5.8,81.3-16.5,118.4-32.9c37.1-16.3,71.6-38.4,102.2-67c32.7-30.5,62.2-62.9,82.5-99.3c20.3-36.5,31.3-77,27.1-123.9Z",
    fill: "url(#eCqFtfLiQTu6-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.060095 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2570.5,1230.9c-.3,14.8-.8,29.7-1.9,44.5-1,14.8-2.6,29.6-5.1,44.3-2,11.3-4.3,23.1-7.7,34.4s-8,22.3-14.3,32.1c-6,9.2-13.4,17.4-21.6,24.7-8.3,7.4-17.2,13.9-26.3,20-17.6,11.9-36,22.9-55.2,32.4-19.2,9.4-39.1,17.3-59.6,22.9-44.9,12.2-92.5,21.7-140.3,26.6-47.9,4.8-96,4.9-141.9-1.8-35.5-5.2-73.1-10.3-109.3-19.4s-71.1-22.2-101-43.4q-6.6-4.7-12.9-9.9t-12.2-11q-2.5-2.4-4.9-4.9t-4.7-5.2c-19.4-21.9-28.8-49.6-30.2-78.2-1.4-28.5,5.1-58,17.5-83.4c13.3-27.3,34.4-44.2,58.5-57.3c24.2-13,51.4-22.1,77-33.5c11.8-5.2,23.2-10.9,33.8-17.8c10.6-6.8,20.4-14.8,28.9-24.5c11.7-13.3,20.8-28,28.6-43.5c7.9-15.4,14.4-31.6,21.1-47.8c6.8-16.4,10.9-34.1,15.5-51.6c4.7-17.5,9.8-34.8,18.5-50.4c4.6-8.3,10.2-15.9,16.6-22.8s13.6-13.2,21.4-18.8c25.5-18.2,57.6-29.8,90.3-35.8c32.6-6.1,65.9-6.6,93.6-2.7c18.3,2.5,36.7,6.3,54.3,12.2s34.4,13.9,49.7,24.7c16.3,11.6,29.3,26.1,40.4,42.2c11,16,20.1,33.6,28.7,51.3q2.6,5.2,5,10.5t4.7,10.7c15.7,36.1,27.4,74,34.9,112.7c7.5,38.6,11,78.1,10.1,117.5Z",
    fill: "url(#eCqFtfLiQTu8-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2574.2,1232.1c-.4,14.9-.9,29.7-1.9,44.5-1.1,14.9-2.7,29.6-5.2,44.3-1.9,11.3-4.2,23.1-7.6,34.4-3.5,11.3-8,22.3-14.3,32.1-6,9.2-13.5,17.4-21.7,24.7-8.2,7.4-17.1,13.9-26.2,20.1-17.6,11.8-36,22.8-55.2,32.3-19.2,9.4-39.1,17.3-59.7,22.9-44.9,12.2-93.3,21.8-142,26.7s-97.6,5-143.6-1.7c-35.4-5.1-73-10.3-109.3-19.4-36.2-9.1-71.1-22.2-101-43.4q-.1-.1-.2-.1-.1-.1-.3-.1-6.6-4.7-12.9-9.9t-12.2-11q-2.4-2.3-4.8-4.9-2.4-2.5-4.7-5.1c-19.4-22-28.8-49.7-30.2-78.3-1.5-28.5,5-58,17.4-83.4c13.3-27.2,34.4-44.2,58.6-57.3c24.1-13,51.4-22.1,76.9-33.5q.8.2,1.6.3.9.2,1.6.4c9.9,2.2,19.6,6.7,27.4,13.1s13.8,14.7,16.3,24.4c.7,2.7,1.2,5.4,1.8,8.1.7,2.7,1.6,5.2,3.1,7.5c2.4,3.7,6.2,5.9,10.4,7.4c4.2,1.4,9,2.1,13.4,2.5q21.2,2.4,42.4,4.7t42.4,4.6q-.1.7-.3,1.4t-.3,1.5c-.6,2.5-1,5.5-1.7,8.4-.7,2.8-1.7,5.6-3.4,7.6-12,13.6-21.6,28.3-30.2,43.7-8.6,15.3-16.2,31.2-24.3,47.2-.4-5.8.6-11.9,1.7-17.9c1.1-6.1,2.4-12.2,2.6-18.1q.1-1.3.1-2.6.1-1.4.3-2.7-2.8.6-5.5,1.2-2.7.7-5.4,1.4c-14.2,3.7-27.1,10.4-39.1,18.7-11.9,8.3-23,18.2-33.6,28.4q-9.3,9-18.9,17.7t-19.5,17.2q.1,0,.2.1t.2.1c2.8,2,5.6,4,8.2,5.9c2.7,1.9,5.3,3.7,7.8,5.1q11,6,22.4,11.2q11.4,5.1,23.2,9.4c30.6,11.1,62.9,17.7,95.3,19.5c32.5,1.9,65.3-1,96.9-9c43.5-10.9,84.2-30.8,120.5-57.2s68.3-59.1,94.3-95.7c26.1-36.6,46.5-76.7,62.1-118.8c15.6-42,26.4-86.1,33.2-130.5.8-5,1.5-10.2,2.2-15.3.8-5.2,1.5-10.4,2.3-15.4c16.9,36.8,29.5,74.8,37.6,113.4c8,38.6,11.7,77.8,10.8,117.2Z",
    fill: "url(#eCqFtfLiQTu9-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2233.3,1202.2c8.9-4.8,18.2-9.1,27.7-12.5s19.4-5.8,29.4-6.6c10.1-.9,20.5-.1,30.2,2.7s18.8,7.6,26.1,14.5c1.2,1.1,2.3,2.3,3.3,3.5.9,1.3,1.7,2.7,2.1,4.2.3,1.2.3,2.4.3,3.7-.1,1.2-.3,2.4-.5,3.6-2.2,11.1-8.2,20.6-16,28.8s-17.4,15.2-27.1,21.1c-17.4,10.6-35.8,19.6-54.9,26.8-19.2,7.1-39,12.4-59.1,15.8-5.1.9-10.3,1.6-15.5,1.6s-10.2-.6-15-2.5c-28.1-11.2-15.9-34.7,5.8-56.7s53-42.6,63.2-48Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eCqFtfLiQTu11",
    transform: "matrix(.506432 0.182943-.195572 0.541392 2490.232009 447.586393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.06,235.83c4.025002.152295,7.416798-2.975843,7.59-7l1-23.66h4.32c.510599,4.183971.767734,8.394989.77,12.61.017468,13.057462-2.442705,25.999673-7.25,38.14h-23.41v-20.78Z",
    fill: "url(#eCqFtfLiQTu12-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.39,304.14c9.193386,5.404503,19.409177,8.840414,30,10.09c1.062467.085012,2.063516-.507609,2.5-1.48q12.91-32.88,22.5-66.88c.239379-1.039086-.201143-2.116364-1.1-2.69-9.193386-5.404503-19.409177-8.840414-30-10.09-1.062467-.085012-2.063516.507609-2.5,1.48q-12.91,32.88-22.5,66.88c-.239379,1.039086.201143,2.116364,1.1,2.69Z",
    fill: "url(#eCqFtfLiQTu13-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.51,310.6c3.799726,1.707851,7.754501,3.047317,11.81,4c4,.92,8.53-1.88,9.89-5.71q13.44-38.12,25.78-76.62c1.24-3.88-.67-8.84-4.42-10.53-3.799726-1.707851-7.754501-3.047317-11.81-4-4-.92-8.52,1.88-9.89,5.71q-13.44,38.12-25.78,76.62c-1.23,3.93.67,8.84,4.42,10.53Z",
    fill: "url(#eCqFtfLiQTu14-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.59,312.4c2.172811,1.869072,4.989325,2.816282,7.85,2.64.70118-.084981,1.305543-.533502,1.59-1.18q13.79-40,27-80.28c.162091-.68779-.05079-1.410067-.56-1.9-2.172811-1.869072-4.989325-2.816282-7.85-2.64-.70118.084981-1.305543.533502-1.59,1.18q-13.79,40-27,80.28c-.162091.68779.05079,1.410067.56,1.9Z",
    fill: "url(#eCqFtfLiQTu15-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.2,235.83c-4.025002.152295-7.416798-2.975843-7.59-7l-1-23.66h-4.27c-.510599,4.183971-.767734,8.394989-.77,12.61-.017468,13.057462,2.442705,25.999673,7.25,38.14h23.36v-20.78Z",
    fill: "url(#eCqFtfLiQTu16-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.87,304.14c-9.193386,5.404503-19.409177,8.840414-30,10.09-1.062467.085012-2.063516-.507609-2.5-1.48q-12.91-32.88-22.5-66.88c-.239379-1.039086.201143-2.116364,1.1-2.69c9.193386-5.404503,19.409177-8.840414,30-10.09c1.062467-.085012,2.063516.507609,2.5,1.48q12.91,32.88,22.5,66.88c.239379,1.039086-.201143,2.116364-1.1,2.69Z",
    fill: "url(#eCqFtfLiQTu17-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.74,310.6c-3.799726,1.707851-7.754501,3.047317-11.81,4-4,.92-8.53-1.88-9.89-5.71q-13.44-38.12-25.78-76.62c-1.24-3.88.67-8.84,4.42-10.53c3.799726-1.707851,7.754501-3.047317,11.81-4c4-.92,8.52,1.88,9.89,5.71q13.44,38.12,25.78,76.62c1.24,3.93-.66,8.84-4.42,10.53Z",
    fill: "url(#eCqFtfLiQTu18-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67,312.4c-2.172811,1.869072-4.989325,2.816282-7.85,2.64-.70118-.084981-1.305543-.533502-1.59-1.18q-13.79-40-27-80.28c-.162091-.68779.05079-1.410067.56-1.9c2.172811-1.869072,4.989325-2.816282,7.85-2.64.70118.084981,1.305543.533502,1.59,1.18q13.79,40,27,80.28c.162091.68779-.05079,1.410067-.56,1.9Z",
    fill: "url(#eCqFtfLiQTu19-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.87,216.33v-18.84c0-53.521915,43.388085-96.91,96.91-96.91h4.43c53.521915,0,96.91,43.388085,96.91,96.91v18.84c.005352,1.706608.894718,3.288544,2.35,4.18q4.88,3,9.45,6.46c.536909.4015,1.25458.465191,1.853805.16452s.977143-.914093.976195-1.58452v-28.06c0-61.35-50.2-111.55-111.55-111.55h-4.43c-61.35,0-111.55,50.2-111.55,111.55v28.06c-.015507.679443.359386,1.307765.964677,1.616804s1.334079.244217,1.875323-.166804q4.57-3.43,9.45-6.46c1.468222-.894588,2.362961-2.490711,2.36-4.21Z",
    fill: "url(#eCqFtfLiQTu20-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.9,144.73c-1.556167-.015621-3.016331-.754945-3.95-2-17.689775-23.146027-45.158116-36.723056-74.29-36.72h-4.45c-29.131884-.003056-56.600225,13.573973-74.29,36.72-1.513768,1.962584-4.236851,2.519965-6.4,1.31l-12.69-7.2c-.115353-.068685-.225636-.145549-.33-.23-.462482-.320126-.605434-.939586-.33-1.43c20.831772-31.364715,55.967562-50.234909,93.62-50.28h4.43c37.827102.03257,73.105108,19.074953,93.89,50.68.152415.230913.202349.514654.137922.783728s-.237453.49943-.477922.636272l-12.41,7c-.742535.453187-1.590459.704807-2.46.73Z",
    fill: "url(#eCqFtfLiQTu21-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eCqFtfLiQTu22",
    transform: "matrix(.416969 0.194259-.194259 0.416969 1600.018964 553.279697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.58,117.84c-.360524-2.15534-2.300123-3.68364-4.48-3.53-9.251527.663986-18.448552,1.943485-27.53,3.83-2.531224.538936-4.917927,1.612952-7,3.15-1.096398.797158-1.740645,2.074479-1.73,3.43v8.64c.010952,2.453117,1.996883,4.439048,4.45,4.45h31.92c2.453117-.010952,4.439048-1.996883,4.45-4.45v-15c-.016294-.174771-.043008-.348413-.08-.52Z",
    fill: "url(#eCqFtfLiQTu23-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.42,117.84c.360524-2.15534,2.300123-3.68364,4.48-3.53c9.251527.663986,18.448552,1.943485,27.53,3.83c2.531224.538936,4.917927,1.612952,7,3.15c1.096398.797158,1.740645,2.074479,1.73,3.43v8.64c-.010952,2.453117-1.996883,4.439048-4.45,4.45h-31.87c-2.453117-.010952-4.439048-1.996883-4.45-4.45v-15c-.000254-.173773.009764-.347409.03-.52Z",
    fill: "url(#eCqFtfLiQTu24-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.37,126.6c-48.73-9.42-40.82,1.3-54.46,2.13-6.11.37-31.45,0-40.91,0s-34.8.37-40.91,0c-13.64-.84-5.73-11.55-54.46-2.13-22.24,4.3-42.31,87.58-39.62,133c3.38,57,23.94,64,47.32,28.11s22.82-45.93,50.38-45.93h74.59c27.56,0,27,10,50.38,45.93s43.94,28.89,47.32-28.11c2.68-45.42-17.39-128.7-39.63-133Z",
    fill: "url(#eCqFtfLiQTu25-fill)",
    stroke: "#e6e6e6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,128.78c-7.37.3-31,0-40,0s-32.64.34-40,0v113c.88,0,1.78,0,2.71,0h74.59c.94,0,1.84,0,2.71,0Z",
    fill: "url(#eCqFtfLiQTu26-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.62,198.51c-3.849369,1.125841-7.940631,1.125841-11.79,0-1.428081-.542522-2.395615-1.883697-2.46-3.41v-36.57c.064385-1.526303,1.031919-2.867478,2.46-3.41c3.849369-1.125841,7.940631-1.125841,11.79,0c1.428081.542522,2.395615,1.883697,2.46,3.41v36.57c-.064385,1.526303-1.031919,2.867478-2.46,3.41Z",
    fill: "url(#eCqFtfLiQTu27-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.42,170.92c1.125841,3.849369,1.125841,7.940631,0,11.79-.542522,1.428081-1.883697,2.395615-3.41,2.46h-36.57c-1.537384-.052574-2.893238-1.022167-3.44-2.46-1.125841-3.849369-1.125841-7.940631,0-11.79.542522-1.428081,1.883697-2.395615,3.41-2.46h36.59c1.529999.060462,2.876057,1.028679,3.42,2.46Z",
    fill: "url(#eCqFtfLiQTu28-fill)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 29.71,
    transform: "translate(159.99 218.15)",
    fill: "url(#eCqFtfLiQTu29-fill)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 18.86,
    transform: "translate(159.99 218.15)",
    fill: "url(#eCqFtfLiQTu30-fill)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 29.71,
    transform: "translate(240.01 218.15)",
    fill: "url(#eCqFtfLiQTu31-fill)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 18.86,
    transform: "translate(240.01 218.15)",
    fill: "url(#eCqFtfLiQTu32-fill)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 9.46,
    transform: "translate(281.27 156.1)",
    fill: "url(#eCqFtfLiQTu33-fill)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 9.46,
    transform: "translate(281.27 197.53)",
    fill: "url(#eCqFtfLiQTu34-fill)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 9.46,
    transform: "translate(260.56 176.82)",
    fill: "url(#eCqFtfLiQTu35-fill)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 9.46,
    transform: "translate(301.99 176.82)",
    fill: "url(#eCqFtfLiQTu36-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.94,309.18l18-64c5.988819-21.631203-6.600793-44.041515-28.19-50.18v0c-.47-.13-.94-.24-1.41-.36-4.86,22.73-7.41,46.85-6.33,64.94c1.8,30.42,8.51,46.59,17.93,49.6Z",
    fill: "url(#eCqFtfLiQTu37-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.07,245.2l18,64c9.42-3,16.12-19.19,17.93-49.63c1.07-18.09-1.48-42.2-6.33-64.94-.47.11-.94.23-1.41.36v0c-21.604245,6.138178-34.197949,28.569178-28.19,50.21Z",
    fill: "url(#eCqFtfLiQTu38-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.053076 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2270,732.3q.1-.2.2-.3t.2-.3q.7-1.2,1.6-2.3t1.9-2.2q.8-1.1,1.8-2.1.9-1,1.9-1.9q2.1-1.9,4.5-3.3q2.4-1.3,5.2-1.9c4-.9,7.4.4,9.9,2.9c2.4,2.5,4,6.1,4.6,9.8.9,6.7-2.5,14.7-8,20.3-5.4,5.6-12.9,8.8-20.2,5.7q-1.4-.7-2.6-1.7-1.1-1-1.9-2.3c-.9-1.5-1.5-3.1-1.8-4.7-.4-1.6-.5-3.3-.5-5c0-1.9.4-3.7.9-5.6.6-1.8,1.3-3.5,2.3-5.1Z",
    fill: "url(#eCqFtfLiQTu40-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2285.5,872.8q-.7-.3-1.3-.6-.7-.3-1.4-.6c-.2,2.1-1.2,3.9-2.5,5.5s-2.9,2.9-4.5,4.2c-4,3-8.3,5.7-12.9,7.8-4.5,2.2-9.2,3.7-14.2,4.5-8.6,1.2-17.1,0-25.4-2.7-8.2-2.6-16.2-6.7-23.7-11.2-1.3-.8-2.8-1.7-4.1-2.7-1.3-.9-2.6-2-3.6-3.3-.5-.6-.7-1.3-.9-2.2-.2-.8-.2-1.6-.3-2.3q0-1.3.1-2.5.2-1.2.4-2.4c0-.1.3-.8.5-1.5s.4-1.5.4-1.5c1.1-2.5,1.7-3.8,2.2-5s.9-2.3,1.6-4.5c.7-2,1.1-4.2,1.5-6.4s.7-4.5,1-6.6q0-.2,0-.4.1-.2.1-.4.4-2.5.5-5.2.1-2.6-.1-5.2c-.2-3.2.5-4.2,1.9-4.5s3.6.1,6.3-.3c2.8-.5,5.5-1.5,8-2.8c2.6-1.3,5-3,7.3-4.7c4.3-3.2,8.3-6.8,12.2-10.6c3.8-3.9,7.5-7.9,11.1-11.9c3.3-3.6,6.5-7.2,9.4-11.2c2.8-3.9,5.2-8.1,6.7-12.7.6-1.9.4-6.4.8-10.2.5-3.8,1.6-6.9,4.7-6.1.3,0,.2,7.5,0,15.2s-.4,15.8-.5,17.2c-.1,5.4,0,11,.3,16.7.2,5.7.7,11.4,1.2,16.8.7,6.6,2.2,13.1,4.1,19.5c2,6.4,4.3,12.9,6.7,19.4q1.5,4,3.1,7.8q1.6,3.9,3.3,7.6Z",
    fill: "url(#eCqFtfLiQTu41-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2279.1,857.4q-.1.1-.2.1-.2,0-.3.1c-8.6,1.8-17.3,2.4-26,1.8s-17.3-2.4-25.6-5.2q-6.2-2.2-12.1-5.1-5.9-3-11.3-6.8c-.8-.5-1.7-1.1-2.6-1.7s-1.8-1.2-2.6-1.8q0-.2,0-.4.1-.2.1-.4.4-2.5.5-5.2.1-2.6-.1-5.2c-.2-3.2.5-4.2,1.9-4.5s3.6.1,6.3-.3c2.8-.5,5.5-1.5,8-2.8c2.6-1.3,5-3,7.3-4.7c4.3-3.2,8.3-6.8,12.2-10.6c3.8-3.9,7.5-7.9,11.1-11.9c3.3-3.6,6.5-7.2,9.4-11.2c2.8-3.9,5.2-8.1,6.7-12.7.6-1.9,1.1-6.2,2.1-9.8c1.1-3.6,2.8-6.5,6-5.8.3.1-.1,7.3-.5,14.7-.4,7.5-1,15.3-1,16.7q-.2,8,.1,16.1.2,8.1,1,16.2c.6,6.6,1.9,13.5,3.5,20.3c1.7,6.8,3.7,13.6,6.1,20.1Z",
    fill: "url(#eCqFtfLiQTu42-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2273.1,712.7q-.2,1.7-.6,3.2-.3,1.6-.7,3.1c-.7,2.6-1.5,5.1-2.1,7.8-.7,2.7-1.2,5.5-1.4,8.8-.2,5.2-.7,13.9-1.5,23.5-.7,9.5-1.6,19.9-2.6,28.5q-.1,1-.2,2t-.2,2.1c-.2,1.2-.3,2.5-.6,3.7s-.7,2.4-1.5,3.3c-.7.9-1.5,1.7-2.4,2.5-.8.8-1.7,1.6-2.5,2.3-5.5,5.6-12.3,11.5-19.8,16.6s-15.6,9.3-23.7,11.4q-1.8.4-3.5.7-1.8.3-3.5.5-.2,0-.4,0-.2.1-.4.1-1.5.1-3,.1-1.4,0-2.9-.1h-.7-.7q-.1,0-.1-.1-.1,0-.2,0-.4,0-.9-.1-.4-.1-.9-.2-.3,0-.5-.1-.3-.1-.6-.2-.2,0-.3-.1-.2,0-.4-.1-.9-.2-1.7-.5t-1.6-.7c-1.3-.6-2.5-1.5-3.6-2.5s-2.1-2.1-3.2-3.1q-2-2.1-4-4.2t-3.9-4.2q-3.7-4.4-7.1-9.1-3.3-4.7-6.3-9.6c-2.6-4.2-5-8.3-6.6-12.7-1.6-4.3-2.4-8.9-1.8-14c.4-3.6.9-7.3,1.1-11c.2-3.8.2-7.5-.2-11.2q-.2-2.1-.5-4-.4-1.9-.9-3.8c-.7-2.8-1.7-5.5-2.6-8.3-1-2.7-1.9-5.4-2.7-8.2q-.9-3.2-1.4-6.5-.5-3.2-.5-6.5c0-5.1.6-10.6,1.8-16.1c1.1-5.4,2.9-10.8,5.2-15.6q.4-.9.9-1.8.4-.9,1-1.7c.7-1.2,1.6-2.3,2.7-3.1c1.1-.9,2.3-1.6,3.7-2.1q.9-.3,1.7-.6.9-.2,1.8-.5.5-.1,1-.2.4-.1.9-.2t1.1-.2q.5-.1,1-.2.7,0,1.4-.1t1.3-.2q.5-.1,1-.1.4-.1.9-.1q1.5-.1,2.8-.3q1.3-.1,2.5-.3q9-1.3,18-2.4t18-2c4.6-.4,9.2-.3,13.8,0c4.6.2,9.2.7,13.8.9q1,.1,1.9.2q1,0,1.8.2.5.1,1.1.2.5.1,1.1.2.7.2,1.4.3.7.2,1.4.4q1.5.4,2.9.9q1.4.4,2.8,1q2,.9,3.9,2q2,1.1,3.8,2.3.7.6,1.4,1.1.7.6,1.4,1.2c1.8,1.7,3.1,3,4,4.5c1,1.5,1.5,3.2,1.7,5.7l.1.7v.7c.5,4.3.5,8.7.3,13-.1,4.4-.5,8.8-1,13.2Z",
    fill: "url(#eCqFtfLiQTu43-fill)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2272.5,712.6q-.2,1.6-.4,3.2-.1,1.6-.3,3.2c-.7,2.6-1.5,5.1-2.1,7.8-.7,2.7-1.2,5.5-1.4,8.8-.2,5.2-.7,13.9-1.5,23.5-.7,9.5-1.6,19.9-2.6,28.5q-.1,1-.2,2t-.2,2.1c-.2,1.2-.3,2.5-.6,3.7s-.7,2.4-1.5,3.3c-.7.9-1.5,1.7-2.4,2.5-.8.8-1.7,1.6-2.5,2.3-5.5,5.6-12.3,11.5-19.8,16.6s-15.6,9.3-23.7,11.4q-1.8.4-3.5.7-1.8.3-3.5.5-.2,0-.4,0-.2.1-.4.1-1.5.1-3,.1-1.4,0-2.9-.1h-.7-.7q-.1,0-.1-.1-.1,0-.2,0-.4,0-.9-.1-.4-.1-.9-.2-.3,0-.5-.1-.3-.1-.6-.2-.2,0-.3-.1-.2,0-.4-.1c0,0,1.6,0,3.6-.2c1.9-.1,4.2-.4,5.6-.8c4.3-1.4,8.6-3,12.6-5.1c4-2,7.9-4.5,11.4-7.3q1.7-1.3,3.3-2.8t3.1-3.1c7.8-8.5,12.3-18.1,15-28.3c2.6-10.2,3.4-21,3.7-31.9.2-5,0-10-.4-15-.5-5-1.1-10-1.9-14.9-.7-4.5-1.3-9-2.2-13.4-.9-4.5-2.1-8.8-4.1-12.9-.9-1.8-1.7-3.8-2.8-5.5s-2.5-3.2-4.6-3.9c-1.5-.4-3.5-.5-5.4-.3-2,.1-4,.4-5.6.5-4.2.5-8.3.9-12.5,1.3s-8.4.7-12.7.7-8.6-.1-13-.5-8.7-.9-13-1.7c-2.3-.5-4.7-1.1-7-1.7-2.4-.6-4.7-1.4-6.8-2.3-.7-.3-1.8-.7-3.1-1.1-1.3-.5-2.6-1-3.7-1.6q.4-.9.9-1.8.4-.9,1-1.7c.7-1.2,1.6-2.3,2.7-3.1c1.1-.9,2.3-1.6,3.7-2.1q.9-.3,1.7-.6.9-.2,1.8-.5.5-.1,1-.2.4-.1.9-.2t1.1-.2q.5-.1,1-.2.7,0,1.4-.1t1.3-.2q.5-.1,1-.1.4-.1.9-.1q1.5-.2,2.8-.3q1.3-.2,2.4-.4q9-1.3,18-2.4q8.9-1,18-1.9c4.6-.4,9.2-.3,13.8-.1c4.6.3,9.2.7,13.9,1q1,.1,1.9.2q1,0,1.8.2.5.1,1.1.2.5.1,1.1.2.7.2,1.4.3.7.2,1.4.4q1.5.4,2.9.9q1.4.4,2.8,1q2,.9,3.9,2q2,1.1,3.8,2.3.6.6,1.3,1.1.7.6,1.3,1.2c1.8,1.7,3.2,3,4.1,4.5s1.5,3.2,1.7,5.6v.7l.1.8c.4,4.3.4,8.6.1,13-.3,4.3-.8,8.7-1.3,13.1Z",
    fill: "url(#eCqFtfLiQTu45-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2210.2,724.1c-.6,3.1-1.3,6.5-1.5,9.9s-.1,6.8,1,9.8c.3.9.6,1.7.9,2.5.4.7.8,1.4,1.5,2.2c1.2,1.3,2.8,1.9,4.5,2.4c1.7.4,3.4.7,5.1,1.2q1.6.4,3.1.8q1.6.5,3.2.7c5.8.6,11.2-1.7,15.4-5.3c4.2-3.7,7.2-8.8,8.2-13.7.5-2.5.8-6.9,0-10.6-.8-3.8-2.7-6.9-6.9-7-.8,0-1.7,0-2.5-.1-.8,0-1.7,0-2.5,0q-2.5.2-4.8.8-2.4.5-4.7,1.3c-1.8.7-3.6,1.4-5.4,2.2s-3.6,1.5-5.4,2.2c-.8.2-1.5.4-2.1.5-.7,0-1.4-.1-2.1-.4-.6-.2-1.4-.7-2.1-1-.8-.3-1.6-.5-2.1-.1-.3.2-.5.5-.6.8-.2.4-.2.7-.2.9Z",
    fill: "url(#eCqFtfLiQTu47-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2210.3,746.6c.2,1.3.9,2.2,1.8,2.9.9.8,2.1,1.3,3.2,1.9q.1.1.2.1.1.1.1.1c0,0,.2,0,.3.1.2.1.5.1.8.3c1.2.3,2.3.6,3.4.8c1.2.2,2.3.3,3.6.3q.2-.1.5-.1t.5,0q1.2,0,2.4-.1t2.4-.2q1-.1,1.9-.3t1.8-.5q1.8-.5,3.2-1.5t2.4-2.4q0,0,0,0t.1,0c1.2-1.6,2.1-3.4,2.7-5.3s1-3.9,1.1-5.7q0-.4,0-.8t0-.8c0-1-.2-2-.7-2.9s-1.2-1.5-2.4-1.9c-1.5-.5-3-.7-4.5-.8s-3.1,0-4.6.1c-3.6.2-7.3.7-10.4,1.9-3.2,1.3-5.9,3.3-7.6,6.5q-.6,1.2-1.1,2.4t-.8,2.4q-.2.6-.3,1.3-.1.6,0,1.3c0,.1,0,.2,0,.4s0,.3,0,.5Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2148.7,724.7q0,0,.1,0q0,.1,0,.1c.7,2.8,1.6,5.5,2.6,8.2.9,2.8,1.8,5.5,2.6,8.4.4,1.2.5,1.5.6,1.9.1.3.3.6.7,1.9c0,0,.5.8,1,1.7.5.8,1,1.7,1,1.7c0,.1.1.3.1.5.1.2.1.4.2.5c1.6,1.9,3.1,3.6,4.9,4.8c1.7,1.2,3.7,1.9,6.3,1.8c1.5,0,3-.2,4.4-.8s2.7-1.5,3.5-2.7s1.3-2.6,1.5-4c.3-1.4.3-2.8.2-4.2-.3-3.2-1.1-6.6-2.4-9.8s-3.1-6.2-5.3-8.5c-.2-.2-.4-.2-.7-.3-.2-.1-.5-.2-.8-.3q-2.4-.8-4.8-1.3-2.4-.6-4.9-.9c-1.6-.3-3.6-.5-5.5-.5-2,.1-3.9.6-5.3,1.8Z",
    fill: "url(#eCqFtfLiQTu50-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2154.9,743.8q.1.5.1.9.1.5.2,1c0,.2.1.4.2.6.2.2.3.4.4.6.1.9.2,1.7.4,2.6.2.8.4,1.6.8,2.3q.1.1.2.3q0,.1.1.2c.6.9,1.4,1.6,2.3,2.1c1,.5,2,.8,3.1,1.1q.2.1.4.2.2,0,.4.1.6.2,1.3.3.7.2,1.4.3c1.7.3,3.6.5,5.3.3c1.8-.2,3.4-.8,4.6-1.8q.4-.4.8-.9.3-.5.6-1.1q0-.1,0-.2.1-.1.1-.2.5-1.2.4-2.6q0-1.3-.4-2.6c-.4-1.3-.9-2.5-1.6-3.6s-1.5-2.1-2.3-3c-1.7-1.9-4.1-3.1-6.7-3.9-2.5-.7-5.4-1-7.9-.8-.9,0-1.9.1-2.6.5-.7.3-1.3.9-1.4,1.8q-.2.7-.2,1.4-.1.7-.1,1.4t0,1.4q0,.6.1,1.3Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2193.9,777.8c-1.1.5-2.3.9-3.4,1.3-1.2.4-2.4.6-3.6.7q-1.7.1-3.4.1t-3.3-.2q-.8-.1-1.6-.3t-1.5-.4c-.3-.1-.5-.2-.7-.2-.1,0-.2.1-.3.5q0,.3,0,.6.1.2.1.5-.1-.3-.2-.6q0-.3,0-.7c.1-.5.3-1.1.6-1.6.3-.4.6-.7.9-.6c1,.3,2.1.6,3,.7.9.2,1.6.3,2.1.3c1.6.1,3,.2,4.5.1s3-.3,4.5-.7q1.1-.2,2.1-.5t2-.6c.4-.1.8-.2,1.2-.4.5-.2,1.1-.5,2.1-1.2q-.4.4-.9.8-.6.4-1,.7-.8.5-1.6.9t-1.6.8Z",
    fill: "#ffe5d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2176.1,779.3c.1-.4.2-.5.3-.5.2,0,.4.1.7.2q.7.2,1.5.4t1.6.3q1.6.2,3.3.2t3.4-.1c1.2-.1,2.4-.3,3.6-.7c1.1-.4,2.3-.8,3.4-1.3q.8-.4,1.6-.8t1.6-.9q.4-.3,1-.7.5-.4.9-.8.2-.2.3-.4.2-.1.2-.3.6.2,1,.5.5.3.8.5c.7.4,1.5.8,2.3,1.2.7.4,1.5.8,2.1,1.3q.7.7.9,1.5t-.1,1.7c-.1.4-.3,1.2-.5,1.9s-.4,1.3-.5,1.4c-.5.2-1.3.3-2.1.4-.9,0-1.8-.1-2.4-.1-1.3,0-2.6.2-3.8.6-1.2.3-2.5.8-3.7,1.3q-1.6.6-3.4,1t-3.5.6c-1.2.2-2.4.2-3.5,0s-2.2-.6-3.1-1.3-1.8-1.5-2.4-2.5c-.7-1-1.2-2-1.3-3.1q0-.1-.1-.2q0-.1,0-.2q0-.3-.1-.5q0-.3,0-.6Z",
    fill: "url(#eCqFtfLiQTu53-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2176.1,782.3q.6,1.2,1.5,2.3.9,1,2,1.8c.5.2.9.5,1.4.7.5.3,1,.5,1.6.5q-.5-.2-.8-.4-.2-.1-.4-.2-.6-.3-1.1-.8-.5-.4-1-.9-.5-.4-1-.9t-.8-1.1c-.4-.5-.7-1-.9-1.6-.3-.6-.4-1.2-.4-1.9q0-.4.1-.8q0-.4.2-.7.3-.6.8-1q.4-.5.8-1q.4-.4.7-.9.3-.4.6-.9c.5-.7,1-1.7,1.4-2.7.5-1,.9-2,1.1-2.8.4-1.1.6-2,.8-2.8.2-.9.3-1.8.6-2.9q.9-4.6.7-9.2-.1-4.6-1.4-9.1-.8-3-2.2-5.9-1.5-2.9-3.3-5.4-.4-.5-.8-1-.3-.5-.7-1-.4-.4-.8-.7-.3-.3-.8-.6q0-.1-.1-.1q0,0-.1.1-.1,0,0,.1q0,.1.1.2c1.1,1.2,2.1,2.5,3.1,4c.9,1.4,1.8,2.9,2.4,4.4.4.9.8,1.7,1.1,2.5.4.8.6,1.6.9,2.5.9,2.6,1.4,5.4,1.6,8.1.2,2.8.2,5.6-.2,8.3-.1,1.1-.3,2.4-.6,3.7-.2,1.3-.5,2.6-.8,3.6-.5,1.5-.9,2.7-1.4,4-.5,1.2-1.1,2.3-1.9,3.6q-.4.5-.8.9-.4.5-.8.9-.4.3-.6.7t-.3.8c-.1.6-.1,1.2,0,1.9.1.6.3,1.2.5,1.7Z",
    fill: "url(#eCqFtfLiQTu54-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2148.3,663.2c1.8-1.1,3.7-2.1,5.6-2.9c2-.8,3.9-1.5,6-2.2c2.4-.8,4.6-1.2,6.9-1.4s4.5-.3,7-.5c-3.7-3.2-8.1-5.9-12.6-8.1-4.6-2.2-9.5-3.8-14.3-4.6.5-2.5,2.7-4.9,5.2-7.1c2.6-2.2,5.5-4,7.5-5.2c6.2-3.7,12.8-6.3,19.6-7.9c6.8-1.5,13.9-2.1,21.1-1.8c4,.2,7.9.6,11.8,1.4c3.8.8,7.6,1.8,11.4,3.1c2.3.8,4.4,1.8,6.6,2.8c2.1,1,4.2,2,6.4,2.9c1.9.9,3.8,2,5.6,3.2c1.8,1.1,3.5,2.2,5.5,3.2c1.2-2.1,3.4-3.9,5.9-5.2c2.4-1.4,5.1-2.4,7.5-2.8q2.9-.6,5.9-.4q3,.1,5.9.7c1.2.3,3.3.7,5.3,1.4c1.9.7,3.7,1.7,4.2,3.1-4.5-.3-9,.7-12.7,3-3.7,2.2-6.6,5.7-7.9,10.2c3.3-.6,6.6-.5,9.9,0c3.4.4,6.6,1.3,9.6,2.6q1.9.7,3.7,1.6q1.8,1,3.4,2.1c.9.7,2.1,1.4,3.1,2.3s1.9,1.9,2.3,3c-2.6-.5-5.1.4-7.2,2-2,1.5-3.7,3.8-4.8,6-1.1,2.1-1.7,4.2-2.2,6.5-.4,2.2-.7,4.4-1,6.7-.3,2.4-.8,4.7-1.2,7.1-.4,2.3-.8,4.7-1.1,7.1-1.1,9.9-2.9,19.5-4.3,29.2s-2.3,19.4-1.7,29.4c.1,1.4-.3,1.9-.9,2-.7.2-1.6-.1-2.5-.4-.1,0-.6-.1-1.1-.2s-1-.2-.9-.4q.1-1.8.2-3.6.2-1.9.2-3.7.1-1.8.1-3.6t.1-3.6q0-.7,0-1.5q0-.7,0-1.4t0-1.4q0-.6,0-1.3c0-6.4,0-12.6-.1-18.8s-.5-12.4-1.4-18.7q-.2-1.4-.4-2.8t-.6-2.7q-.1-.2-.2-.4t-.2-.3q-.1-.2-.3-.2-.1-.1-.3-.2-.9-.4-1.9-.7t-2-.6c-.4,0-1.1-.1-1.8-.3s-1.3-.4-1.6-.7q-.1-.1-.1-.2t-.1-.2q-.3-1.9-.4-3.8t-.2-3.8q0-1.1-.1-2.2t-.2-2.2q0-.7-.1-1.3q0-.7,0-1.4q0-.1,0-.3q0-.1-.1-.3q0-.5,0-1.1-.1-.5-.1-1.1c-2.9,1.4-6.1,2.5-9.4,3.4-3.3.8-6.6,1.4-9.8,1.9-7,1.2-14,2.8-21.1,4.1s-14.2,2.3-21.4,2.2q-5.4-.1-10.7-.5t-10.6-1c-3.3-.4-6.4-1.2-9.4-2.1-3.1-.9-6.1-1.9-9.2-2.7-2.9-.1-6.4,1.3-9.6,3.1-3.3,1.8-6.4,4-8.4,5.6c1.4-4.2,3.1-8.2,5.5-11.8c2.4-3.7,5.4-6.8,9.2-9.3Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2173.4,722.5c-.8.8-2,.8-3.3.4-1.2-.3-2.5-.9-3.3-1.3-1.3-.6-2.5-1.2-3.8-1.7-1.3-.6-2.6-1.1-4-1.4q-2.5-.8-5.1-1.2-2.7-.3-5.3-.3c-.5.1-.9.1-1.3.2s-.8.3-1.1.7-.4,1-.5,1.6-.1,1.2-.1,1.6q0,1,.2,1.9t.6,1.8q.3.6.8,1.2.5.5,1.1,1q.2.1.3.3.2.1.4.2c.4.2.7.3,1.1.4s.8.2,1.1.2q.8.2,1.5.4.7.1,1.5.2.8.2,1.7.4.8.1,1.7.3q2.9.7,5.9,1.5q3,.7,6,1.3c.8.1,1.8.3,2.8.2.9-.1,1.8-.4,2.4-1.2q.3-.4.4-.9.2-.4.2-.9c.2-1.2,0-2.4-.3-3.6-.4-1.2-.9-2.3-1.6-3.3Z",
    fill: "url(#eCqFtfLiQTu56-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2205.5,719.2c-.1.3.8.4,1.7.5c1,0,2,0,2.1-.1.9-.1,2.2-.3,3.5-.6s2.5-.7,3.4-1c1.5-.5,2.8-1,4.1-1.4c1.2-.5,2.4-.8,3.6-1.1c3-.8,5.4-1.4,7.8-2c2.3-.5,4.7-1,7.8-1.4.8-.2,1.6-.3,2.3-.4.8-.1,1.5-.1,2.3.1q.9.2,1.7.6.8.3,1.6.7q1,.5,1.8,1.2.9.7,1.7,1.4c1.1,1.1,2.1,2.4,2.8,3.8.8,1.4,1.2,2.9,1.3,4.5c0,.5-.5.3-1.2,0-.6-.3-1.3-.8-1.4-.8-1.6-.7-3.3-1-5.1-1-1.7-.1-3.5,0-5.2.1q-3,.2-5.9.7t-5.8,1.3c-2,.4-3.6.8-5.1,1.2-1.6.4-3.1.9-5.1,1.4-1.2.3-2.6.7-3.9,1.1-1.3.3-2.5.6-3.3.6-.9,0-1.6,0-2.4-.2-.7-.2-1.4-.5-2.2-1q-.7-.5-1.2-1.2-.4-.6-.7-1.4c-.4-.8-.7-1.8-.9-2.8-.3-1-.3-2-.1-2.8Z",
    fill: "url(#eCqFtfLiQTu57-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2279,751.4c.8.2,1.8.1,2.8-.2s1.9-.6,2.6-1q1.3-.5,2.4-1.3q1.2-.8,2.1-1.9c1-1.1,1.9-2.6,2.5-4.2.6-1.7,1-3.5.9-5.2q-.1-1.1-.5-2.2-.3-1.1-1-2c-.6-.8-1.5-1.4-2.5-2-.9-.5-2-.9-2.9-1.1-1.9-.3-3.6-.1-5.1.6-1.5.6-2.8,1.7-3.9,3.2q-.7.8-1.2,1.6t-.9,1.7q-.1.1-.2.3-.1.1-.1.3-.2.3-.3.6-.2.4-.4.7c.7-.9,1.5-1.8,2.5-2.4.9-.6,1.9-1,3-1q.8,0,1.6.3t1.5,1c1.4,1.2,1.9,2.9,2,4.7c0,1.8-.5,3.7-1.2,5.1-.5,1-1,1.7-1.6,2.4s-1.3,1.3-2.1,2Z",
    fill: "#910f2e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2203.3,775.8q.4.2.8.4.5.2.9.4.3.2.7.4.3.2.6.5c.5.4.8.9.8,1.4.1.6,0,1.2-.1,1.8q-.2.9-.6,1.7-.3.8-.9,1.5c0,0,.2-.5.4-1.1s.4-1.4.5-2c.1-.3.1-.8.1-1.2s-.1-.8-.2-1.1q-.2-.3-.5-.6-.4-.2-.7-.4-.8-.4-1.5-.9-.8-.4-1.6-.8-.4-.2-.8-.4-.3-.3-.7-.5c-.2-.1-.5-.4-.8-.7-.2-.2-.4-.4-.2-.3q.9.5,1.8,1q1,.4,2,.9Z",
    fill: "#cc5e48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2191.8,785c-.1-.3.1-.5.4-.8s.6-.5.8-.6q.5-.4,1-.7t1.1-.5c.8-.4,1.6-.8,2.4-1.1.8-.2,1.6-.4,2.5-.3.4.1.7.2.9.4.1.3.1.6,0,.9-.2.3-.5.6-.7.8-.3.1-.7.3-1,.4q-.8.3-1.8.5-.9.1-1.8.2-1,.1-1.9.3-.9.1-1.9.5Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2210.3,746.8q0,.1,0,.2t0,.2c.2,1.4.9,2.4,1.9,3.2.9.8,2.1,1.4,3.2,2.1q.1,0,.2.1.1,0,.1.1c0,0,.2,0,.4.1.2,0,.4.1.7.3c1.2.4,2.3.7,3.5.9c1.1.2,2.2.3,3.6.3q.2,0,.4,0q.3,0,.5,0q.9-.1,1.8-.1.9-.1,1.8-.2.2,0,.4,0t.4,0l.2-.1h.2q1-.1,1.9-.3t1.8-.4q.7-.3,1.4-.6t1.3-.7q1.3-.9,2.2-2.1q1-1.1,1.7-2.5.3-.7.6-1.4.3-.8.6-1.5.3-.8.5-1.5.3-.8.4-1.5c.3-1.1.7-2.5.7-3.8.1-1.2-.3-2.4-1.5-3.1q-.7-.5-1.5-.6-.9-.2-1.7-.3-1.7,0-3.4.1t-3.4.4q-2.5.5-4.9,1.1-2.4.7-4.7,1.6-1.8.6-3.6,1.5-1.7.9-3.3,2.1c-.9.7-2,1.6-2.8,2.8-.9,1.1-1.6,2.3-1.6,3.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2210.3,746.7c2-.7,3.9-1.5,5.8-2.2c2-.8,3.9-1.4,6-1.8q1.7-.3,3.4-.6q1.8-.4,3.5-.5.7-.2,1.3-.3.7-.1,1.4-.1q2.6-.1,5.1,0q2.6,0,5.2.2c.2-.5.4-1.2.5-1.8s0-1.2-.5-1.5q-.3-.2-.6-.3-.4-.1-.7-.1c-2.6-.3-5.2-.5-7.7-.5-2.6.1-5.2.3-7.7.8-2.5.4-5,1.2-7.4,2.3-2.3,1-4.5,2.4-6.4,4.1-.3.3-.5.6-.7,1-.1.3-.3.7-.5,1.3Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2228.9,754c.7-1,1.2-2,1.5-3.2.4-1.1.5-2.3.4-3.4-.3-2.8-1.7-5.2-3.8-6.8-2-1.6-4.7-2.5-7.6-2.2-2.2.3-4.3,1.2-5.9,2.6-1.6,1.5-2.8,3.4-3.2,5.5q0,.2,0,.4q0,.3,0,.5c.2,1.2.7,2.1,1.5,2.8s1.7,1.3,2.7,1.8l.4.2.4.2q.1.2.5.3.3.1.8.3c1.2.4,2.2.8,3.1,1c1,.2,2,.3,3.2.3h1h.9c.8-.1,1.4-.1,2.1-.1.6-.1,1.3-.1,2-.2Z",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2210.3,746.8q2.8-1.4,5.8-2.4q2.9-1,6-1.7q1.7-.3,3.4-.6q1.8-.4,3.5-.5c-1.1-1.3-2.5-2.3-4.1-3-1.6-.6-3.3-.9-5.2-.7-2.3.3-4.5,1.3-6.1,2.7-1.7,1.5-2.8,3.5-3.3,5.7q0,.1,0,.2q0,.2,0,.3Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2230.6,747q.1,1.7-.3,3.2-.4,1.6-1.3,2.9-.1.3-.3.5-.1.2-.3.4.2,0,.4,0t.4,0q.1-.1.1-.1q0-.1,0-.2c.7-.9,1.2-2,1.5-3.2.3-1.1.4-2.3.3-3.5-.3-2.9-1.7-5.3-3.7-6.9-2.1-1.7-4.8-2.6-7.7-2.4q.1.1.1.3t.1.3c2.6-.2,5.2.7,7.1,2.2c1.9,1.6,3.3,3.9,3.6,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2213.9,749q.1,1,.5,1.9.4.8,1,1.6.1,0,.2.1.1,0,.1.1c0,0,.2,0,.4.1.2,0,.4.1.7.3c1.2.4,2.3.7,3.5.9c1.1.2,2.2.3,3.6.3c1.2-.6,2.3-1.6,3-2.7.7-1.2,1-2.6.9-4-.2-1.9-1.2-3.5-2.5-4.5-1.4-1.1-3.2-1.7-5.1-1.5s-3.6,1.1-4.7,2.5c-1.2,1.3-1.8,3.1-1.6,4.9Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2080.8,1095.8c0,.7-.2,1.5-.3,2.3-.2.8-.4,1.5-.5,2.3q-.3,1.6-.8,3.2t-1.1,3.2c-.4,1.2-1,2.7-1.7,4-.8,1.3-1.7,2.6-2.9,3.3-1.5.9-3.2,1-4.9.7s-3.3-1-4.9-1.6q-4.4-1.7-8.6-3.9-4.1-2.2-8-4.8c-4.5-3-8.8-6.3-12.7-9.9-4-3.7-7.6-7.6-10.7-12-.3-.5-.8-1.1-1.2-1.7-.4-.7-.6-1.4-.6-2c.1-.6.4-1.2.8-1.7.5-.5,1-.9,1.5-1.2c1.2-.6,2.7-.8,4.2-.9s3.1-.1,4.3,0q2.8,0,5.7.3q2.8.3,5.5.8c4.7.8,9.3,1.8,13.8,3.3s8.9,3.3,13,5.8q1.9,1.2,3.6,2.6q1.8,1.3,3.4,3c.5.5,1,1,1.5,1.6s.9,1.3,1.1,2c.1.3.2.5.2.8.1.2.2.4.3.5Z",
    fill: "url(#eCqFtfLiQTu68-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1976.1,1135.7q1.3.1,3,.2q1.8.1,3.9.2c4,.2,8.9.4,13.3.6s8.5.4,10.9.6c2.9.2,5.8-.4,8.8-1.2c2.9-.9,5.7-2.1,8.3-3.1c3.1-1.2,6-2.5,8.9-4c3-1.5,5.8-3,8.8-4.5s6.1-2.8,9.1-4.2c3.1-1.3,6.2-2.7,9.2-4.4s7.9-4.8,11.4-8.7c3.5-3.8,5.6-8.3,3-12.7-.4-.7-.9-1.3-1.4-1.9-.6-.6-1.1-1.1-1.6-1.6q-1.7-1.6-3.6-2.9-1.9-1.2-4-2.1-1.3-.6-2.5-1.1-1.3-.5-2.6-.9c-2-.6-3.8-1.6-5.6-2.5s-3.6-1.9-5.6-2.4c-2.4-.7-5.1-1.1-7.7-1.4-2.7-.2-5.4-.4-8-.7q-.4,0-.8,0-.5,0-.9.1c-1.2.5-2.4,1.6-3.5,2.9-1.2,1.2-2.3,2.5-3.1,3.4q-2,2.1-3.9,4.1-2,2.1-3.9,4.2-4,4.1-8,8.4-4,4.2-7.9,8.4c-4,4.1-8,7.8-12.3,11.2s-8.9,6.4-13.9,9.2c-.4.2-.8.4-1.1.6-.4.3-.7.6-.9,1-.7,1.1-.1,2.4.8,3.4c1,1,2.4,1.7,3.4,1.8Z",
    fill: "url(#eCqFtfLiQTu69-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1983,1136.1c4,.2,8.9.4,13.3.6s8.5.4,10.9.6q.6,0,1.2,0t1.3,0c1.9-.2,3.8-.5,5.7-1.1c1.8-.5,3.7-1.2,5.5-1.8q2.7-1.1,5.4-2.1t5.4-2.1q5.7-2.4,11.3-5.1q5.5-2.6,11-5.5c2.8-1.6,5.7-3.1,8.4-4.9c2.8-1.7,5.4-3.6,7.8-5.9c1.8-1.8,3.8-4.1,4.8-6.5c1.1-2.5,1.2-5.2-.3-7.8-.4-.7-.9-1.3-1.4-1.9-.6-.6-1.1-1.1-1.6-1.6q-1.7-1.6-3.6-2.9-1.9-1.2-4-2.1-1.2,1.4-2.4,2.8t-2.5,2.7q-4.1,4-8.4,7.7-4.4,3.7-8.9,7.2c-2.9,2.2-5.8,4.5-8.8,6.8-3,2.2-6,4.4-9.2,6.2-2.7,1.6-5.7,3-8.7,4.2-3,1.3-6.1,2.4-9.1,3.5-3.1,1.2-6.2,2.1-9.4,3.1-3.1.9-6.2,1.9-9.3,3.1q-1.4.5-2.6,1.2-1.1.7-1.8,1.6Z",
    fill: "url(#eCqFtfLiQTu70-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2022,1078.6c1.2-.5,2.7-.8,4.1-.9c1.5-.1,3,0,4.4,0c2.9,0,5.9.2,8.9.7c2.9.5,5.8,1.3,8.6,2.1c2.8.9,5.5,1.9,8.1,3.1s5.1,2.7,7.3,4.5c3.4,2.7,5.8,5.6,7.5,9s2.6,7.2,2.8,11.8c.1,1.5,0,2.8-.2,3.7-.1.9-.3,1.5-.4,1.7c1.1-.4,2.1-.8,3.2-1.2c1.1-.5,2.3-1.1,3.7-1.9c1.3-.7,3.5-4.5,5.4-8.1c1.9-3.7,3.4-7.2,3.5-7.2q-.1.4-.2.8q0,.3,0,.7c1.8-3,3.2-6.5,4.4-10.2c1.2-3.6,2.2-7.4,3.2-10.6c1.6-5.3,3.2-10.4,5-15.4c1.9-4.9,4-9.8,6.7-14.6-.7,5.1-1.3,11.4-2,18-.8,6.6-1.7,13.6-3,19.9q-2.5,12.3-5,24.6t-4.9,24.6c-.2,1-.9,3-1.3,4.9s-.5,3.7.6,4.4c.7.5,2.6.5,4.5.4c2-.1,4-.3,4.9-.3c4.1.3,8.2.7,12.3,1c4.1.4,8.2.7,12.4,1c6.3.5,12.6.4,18.9.3s12.6-.3,18.9-.1c6.8.2,13.6.9,20.4,1.7c6.8.7,13.6,1.5,20.4,2c6.4.5,12.7,1.3,19,2c6.3.8,12.7,1.4,19.1,1.5q.5,0,1.2.1.6,0,1.2,0c6.5,0,12.9.5,19.4,1.1c6.4.5,12.9,1.2,19.3,1.7q1.2.1,2.4.2q1.2,0,2.3.1c1.4.1,2.7.4,4,.6c1.4.2,2.7.3,4-.1c1.2-.4,2.4-1,3.6-1.6c1.1-.6,2.3-1.2,3.5-1.8c5.2-2.1,10.7-2.8,16.3-3.2c5.6-.3,11.4-.3,16.9-1.1c3.3-.5,6.5-1.2,9.7-2.2c3.2-.9,6.3-2,9.4-3.2c2.2-.8,4.3-1.7,6.4-2.7c2-1,4-2.2,5.7-3.7c2.5-2.2,4.6-4.9,6.1-7.8c1.5-3,2.6-6.2,3.2-9.5.8-4,1.2-8.2,1.4-12.3.1-4.2.1-8.4.2-12.5q0-6.4.1-12.8t.2-12.8c.3-10.1.6-20.2.8-30.3s.2-20.2-.3-30.2c-.6-10-1.2-20.4-2.6-30.7s-3.5-20.4-7-29.8q-1-2.8-2.3-5.4t-2.7-5.1c-4.4-7.5-10-14.2-16.2-20.4-6.2-6.1-13-11.7-19.7-17.1q-2.7-2.1-5.4-4.1-2.7-2.1-5.5-4.2-3.2-2.4-6.5-4.7-3.3-2.4-6.7-4.6-2.9-1.9-5.9-3.7t-6.1-3.5q-.2-.2-.5-.3-.2-.1-.4-.2c-2.2-1.2-4.4-2.5-6.7-3.6-2.3-1.2-4.7-2.2-7.1-2.9-.4,3.7-1.5,6.8-3.4,9.5-1.8,2.8-4.3,5.1-7.3,7.2q0,.1-.1.2-.1,0-.3.1-.1,0-.2.1-.1,0-.2,0c-4,2.7-8.5,4.8-13.1,6.2s-9.5,2.3-14.3,2.5c-5.1.2-10.1-.1-15-1-5-.8-9.9-2.2-14.5-3.9-2.7-.9-5.3-2-7.8-3.3s-4.8-2.9-6.7-4.9q-1.3-1.2-2.3-2.6-1.1-1.5-1.9-3.1c-.6-1.2-.9-2.4-1.5-3.4s-1.4-1.7-3.1-2.1q-.3,0-.8-.1-.4-.1-.9-.3c-.8-.1-1.7-.3-2.6-.4s-1.7-.1-2.3.1q-.7.2-1.8.6-1,.4-2.4,1c-7.1,3.2-20.1,10.2-32.2,18.2-12.2,8-23.5,17-27.2,24.1-.6,1.3-1.4,2.5-2.1,3.7-.8,1.2-1.5,2.4-2.1,3.8-3.5,6.8-6.1,14.2-8.3,21.8-2.3,7.6-4.2,15.3-6.7,22.6-3.1,9.3-6.5,18.6-10.3,27.8-3.9,9.1-8.3,18-13.4,26.5-5.3,8.8-11.4,16.5-18,23.8-6.5,7.2-13.6,14.1-20.8,21.2-2,2.1-5.2,4.1-8,6.4-2.7,2.3-5,4.9-5.3,8.1Z",
    fill: "url(#eCqFtfLiQTu71-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260.2,1080.7c0,5.7.4,11.9,1.4,17.9c1,6.1,2.4,12,4.4,17.4q.8,2.4,1.8,4.8.9,2.3,2,4.7c1.5,3.3,2.9,6.8,4.4,10.3c1.4,3.5,2.9,7,4.6,10.3c1.2,2.4,3.4,6.4,6.1,10c2.8,3.6,6.1,6.8,9.7,7.6c8.3,2,15.1,2.9,22,3.5c6.8.5,13.7.7,22.3,1c1.3.1,4,.1,6.7.1c2.8,0,5.5,0,6.8-.1c7.3-.6,11.9-3.7,15.1-7.5s4.8-8.3,6.1-11.8c1.3-3.7,2.5-8.7,3.3-14c.9-5.2,1.5-10.6,1.7-15.1q.1-1.8.1-3.6.1-1.8.2-3.7.1-1.8.1-3.6.1-1.8.1-3.7c.2-6,.3-12,.4-18.1c0-6,.1-12.1.2-18.1.3-10.1.6-20.2.8-30.3s.2-20.2-.3-30.2c-.6-10-1.2-20.4-2.6-30.7s-3.5-20.4-7-29.8q-1-2.8-2.3-5.4t-2.7-5.1c0,3.9.2,7.8.1,11.8s-.4,8-1.4,12.1c-1.7,6.8-3.8,13.5-6.5,19.9-2.7,6.5-5.9,12.7-9.7,18.6-5.2,8.1-10.8,15.2-17.1,21.8s-13.1,12.6-20.7,18.5c-4.8,3.6-9.7,6.9-14.6,9.9-5,3.1-10.1,6-15.2,8.8q-2.7,1.5-5.4,2.9-2.7,1.5-5.5,3.1c-3.4,1.8-5.7,3.8-7.2,6.3s-2.1,5.6-2.2,9.5Z",
    fill: "url(#eCqFtfLiQTu72-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2103.3,1073.7c-.7,4.7-1.4,9.2-1.9,12.7-.5,3.6-.9,6.1-1,7q-1.2,6.4-2.5,12.8-1.2,6.4-2.6,12.8c-.8,3.8-1.4,8.1-2.2,12.3-.9,4.3-1.9,8.4-3.6,12c5.9,1,12.1,1.5,18.4,1.9c6.2.4,12.4.6,18.4,1.1c6.4.4,12.7.1,19-.3s12.7-.9,19-.7c6.8.2,13.6.9,20.4,1.7c6.8.7,13.6,1.5,20.4,2c6.4.5,12.7,1.3,19,2c6.3.8,12.7,1.4,19.1,1.5c4.6-3.3,8.9-7,12.9-11.1c4.1-4,7.9-8.4,11.6-13q.6-.7,1.1-1.4t1-1.5c1.5-2.5,2.7-5.3,3.6-8.2.8-3,1.2-6.1,1.2-9.2-.7-1.8-.6-4.3-.2-6.8.3-2.5.9-5,1.1-7c.3-2.6.7-5.2,1.1-7.7.4-2.6.7-5.1,1-7.7q.8-6.5,1.7-13q.9-6.6,1.7-13.1q1.7-14.2,4.1-28.3t5.4-28.1c1.6-7.7,3.7-15.4,6.4-22.8c2.6-7.5,5.7-14.8,9.3-21.8q1-2,2.2-4q1.1-1.9,2.2-3.8.2-.5.5-1t.5-1q.3-.5.6-.9t.7-.8q.7-.9,1.4-1.8.8-.9,1.5-1.8-1.4.8-2.7,1.8-1.2.9-2.4,2-1.1,1-2.1,2.1-1.1,1.1-2,2.3c-1.3,1.6-2.5,3.2-3.7,4.8-1.2,1.7-2.4,3.3-3.6,5-2.7,3.6-5.5,7.2-8.3,10.8-2.7,3.6-5.4,7.2-7.8,11.1-4.6,7-9.5,14-14.7,20.7-5.3,6.7-10.9,13.2-16.9,19-6.9,6.9-15.1,12.4-23.8,16.9-8.8,4.6-18,8.1-27.1,11-8.3,2.6-16.9,5.4-25.6,7.5-8.7,2-17.6,3.4-26.3,3.1-3.7-.1-7.8-.4-12-.9-4.3-.4-8.6-1-12.7-1.5-4.5-.5-8.7-1.3-11.7-1.9-3.1-.6-5-1.1-5-1.1s-.6,2.9-1.3,7.3c-.8,4.4-1.9,10.5-2.8,17Z",
    fill: "url(#eCqFtfLiQTu73-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2176.4,870.6c.9,2.2,2,4.4,3.2,6.5c1.1,2.1,2.4,4.1,3.7,6q1.4,2.1,3,4.1t3.4,3.8c3.9,3.9,8.4,7.1,13.2,9.6c4.9,2.6,10.1,4.5,15.4,5.9c14.1,3.4,28.3,4.3,42.3,3.2c14.1-1.2,28-4.4,41.5-9.3c2-.8,4.8-1.9,7.8-3.4s6.1-3.3,8.9-5.3q-3.2-2.4-6.5-4.7-3.3-2.4-6.7-4.6-2.9-1.9-5.9-3.7t-6.1-3.5c-4.2,1.8-8.5,3.5-12.8,5.2-4.2,1.7-8.6,3.3-13,4.8q-.1,0-.2.1-.1,0-.2,0c-5.4,1.9-10.9,3.6-16.5,4.8-5.5,1.2-11.2,2.1-17,2.4-6.4.3-12.5-.5-18.2-2.4-5.8-1.9-11.2-4.9-16.2-8.7q-2-1.6-3.9-3.1t-3.8-3.1q-1.6-1.4-3.2-2.9-1.6-1.4-3.1-3c-.8-.1-1.7-.3-2.6-.4s-1.7-.1-2.3.1q-.7.2-1.8.6-1,.4-2.4,1Z",
    fill: "url(#eCqFtfLiQTu74-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2051.4,1079.1c0,0,.2.1.3.2.2.1.4.2.5.3q2,.8,3.9,1.9q2,1,3.8,2.1q2.3,1.5,4.4,3.1q2.1,1.7,3.9,3.7q2.1,2.3,3.5,5.1q1.5,2.7,2.4,5.7c.6,2,.8,4.1.8,6.2c0,2.2-.2,4.3-.4,6.4.7-.3,1.4-.6,2.1-.9s1.4-.6,1.9-.9q.9-.4,1.7-.9.9-.5,1.6-1c2-1.4,6.5-5.3,10.6-9c4-3.7,7.7-7.1,8-7.7.2-.7,1.5-9.8,3.1-20c1.5-10.2,3.3-21.4,4.4-26.3.3-1.6.7-3.4,1-5.2.3-1.9.6-3.7.9-5.2c2.2-11.9,4.2-23.9,6-35.9c1.7-12,3.3-24,4.7-35.9q.7-6.8,1.1-13.6t.3-13.6q-.1-3.4-.4-6.9-.3-3.4-.8-6.8c-.1-1-.3-1.9-.5-2.8-.3-.9-.6-1.8-.9-2.7-.1-.3-.7-1.6-1.2-2.8-.6-1.2-1.1-2.4-1.1-2.8q-1.1,1.9-2.2,3.7t-2,3.8c-.8,1.6-.7,4.8-.5,8.1s.6,6.6.5,8.6q-.3,4.6-.8,9.2t-1.2,9.1c-1.9,11.9-4.3,23.6-7.5,35.1-3.2,11.4-7.2,22.7-12.3,33.7-4.5,9.7-9.9,18.7-16.1,27.2s-13,16.5-20.2,24.2q-.6.6-1.1,1.2-.6.6-1.1,1.1c-.3.3-.5.5-.7.8-.2.2-.4.4-.4.4Z",
    fill: "url(#eCqFtfLiQTu75-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2177.5,868.5q0,.4,0,.7.1.3.2.7.1.3.2.6t.3.6q.6,1.6,1.4,3.1.7,1.5,1.5,3c.8,1.5,1.7,3,2.5,4.4.9,1.5,1.9,2.8,3,4.2q.1.2.4.5.2.3.5.6q1.8,2.1,3.9,3.9t4.4,3.3q2.3,1.6,4.8,2.9q2.5,1.2,5,2.3q1.3.5,2.7,1q1.3.5,2.6.9c.9.2,1.8.5,2.7.8.8.3,1.8.5,2.6.6h.2.1c3.8.9,7.7,1.3,11.7,1.5c3.9.2,7.9.1,11.9-.1q1.2-.1,2.3-.2q1.2-.1,2.4-.2c1.6-.2,3.1-.4,4.6-.7s2.9-.6,4.5-1c6.6-1.5,12.7-4.4,18.2-8.2c5.6-3.7,10.6-8.4,15-13.5.8-1,1.3-1.6,1.8-2.3.4-.6.9-1.3,1.6-2.3.3-.6.6-.8.6-.9s-.2-.1-.8-.5q-1.4-.8-2.8-1.7-1.4-.8-2.7-1.7-.9-.6-1.8-1.1-1-.4-2.1-.6c-.7-.1-1.3.1-2,.3-.6.2-1.2.5-1.8.8-1.5.7-2.8,1.6-4,2.5s-2.4,1.9-3.6,3q-.9.7-1.8,1.5-.9.7-1.9,1.4c-2.2,1.5-4.7,2.8-7.3,3.9s-5.3,1.9-7.8,2.5c-3.6.9-7.3,1.4-11.1,1.6-3.7.2-7.5,0-11-.7-4.1-.8-8.4-1.8-12.6-3.2-4.1-1.3-8.1-3.1-11.6-5.5-1.6-1.2-3.3-2.4-4.8-3.7-1.6-1.3-3-2.7-4.3-4.3q-.3-.2-.5-.5-.3-.3-.5-.7-.5-.6-1-1.2-.5-.7-.9-1.4-.1-.2-.2-.4t-.2-.4q-.3-.8-.3-1.6q0-.9.4-1.7c0,.1-.4.2-.9.3-.4.1-.9.2-1,.2q-.6.2-1.2.4-.5.2-1.1.4-1,.4-1.9.9-1,.4-1.9.9-.4.1-.9.3-.4.1-.8.3-.5.2-1,.5-.5.2-1,.4c-.5.3-1.2.6-1.8,1s-1.1.9-1.1,1.6Z",
    fill: "#f05960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1990.5,1120.5q-1-.5-2.1-1-1-.5-2-1c-2.2-1-4.3-2.5-6.4-3.7-2.1-1.3-4.3-2.4-6.8-2.6-1.6-.1-3.4.1-5.2.4-1.7.3-3.5.7-5.1,1-.7.2-1.5.2-2.3.3s-1.5.3-2.2.7c-1,.7-1.9,1.6-2.8,2.6s-1.7,2-2.5,3c-.9,1-1.8,2.1-2.6,3.2s-1.7,2.2-2.6,3.3c-.3.4-1.4,1.5-2.4,2.6-1,1.2-1.8,2.3-1.6,2.9.2.5,1.5.7,2.8.8c1.4,0,2.8,0,3.3,0q2.7.2,5.5.5q2.7.2,5.4.6c3,.3,6.1.6,9.1.8c3.1.2,6.1.4,9.1.6c1.8.1,3.5.4,5.2.6s3.5.4,5.2.4c.7-.1,1.6-.1,2.4-.1.8-.1,1.7-.2,2.4-.4.9-.3,1.5-.9,1.8-1.7s.5-1.8.6-2.7.2-1.8.2-2.7c-.1-1-.2-1.9-.6-2.7-.6-1.3-1.4-2.4-2.4-3.3s-2.2-1.7-3.4-2.4Z",
    fill: "url(#eCqFtfLiQTu77-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2210.7,744c-.1.3-.2.8-.3,1.3-.1.4-.2.9-.1,1.2c0-.2.3-.6.6-1c.4-.4.8-.8.9-.9q.4-.3.9-.7.5-.3,1-.5c.6-.4,1.2-.9,1.7-1.3.6-.5,1.1-1,1.8-1.3c1.4-.7,3-1.1,4.6-1.4c1.7-.4,3.3-.5,4.9-.7c1.4-.1,2.8-.1,4.2-.2c1.3,0,2.7,0,4.1,0q2-.1,4-.3t4-.5c.1-1.2-.1-2.5-.5-3.6-.5-1.1-1.4-2-2.7-2.5-1.5-.4-3-.7-4.5-.7-1.5-.1-3.1-.1-4.6,0-3.6.2-7.3.8-10.5,2-3.2,1.3-5.9,3.3-7.6,6.6-.4.7-.8,1.5-1.1,2.2-.4.8-.7,1.5-.8,2.3Z",
    fill: "url(#eCqFtfLiQTu78-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2210.3,746.4c0,0,.9-.7,1.9-1.5.9-.8,2.1-1.7,2.6-2.2.7-.5,1.4-.9,2.1-1.2.8-.3,1.5-.6,2.3-.9q1.1-.3,2.3-.7q1.1-.3,2.3-.4c1-.1,1.9-.2,2.8-.3.8,0,1.7,0,2.7,0q1.5.2,3.1.4q1.6.1,3.1.4c1,.1,2,.3,3,.4s2,.1,3-.1c.4-.1.8-.3,1.2-.6.3-.3.6-.7.9-1.1c0-.1.2-.7.4-1.3s.3-1.2.2-1.2q-1.5.3-3,.4-1.5,0-3,0-2.5-.1-5-.2-2.6,0-5.1.2c-1.6.1-3.3.3-4.9.7-1.6.3-3.2.9-4.7,1.6q-1.3.6-2.6,1.5-1.2.8-2.2,1.8c-.5.4-1.3,1.2-2,2-.8.8-1.4,1.6-1.4,2.3Z",
    fill: "#020102"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2228.7,787.5c0,0-.2.7-.7,1.8s-1.2,2.5-2.3,3.9q-.5.8-1.2,1.4-.6.7-1.4,1.2c-.3.3-1.3.7-2.2,1-1,.4-2,.7-2.6.9.2-.1.6,0,1.1,0s1.2,0,1.9-.1c.6-.1,1.3-.3,2-.5.6-.3,1.3-.6,1.8-1s1.2-1.1,1.9-2.5c.7-1.3,1.4-3.2,1.7-6.1Z",
    fill: "url(#eCqFtfLiQTu81-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2223.6,742.2c-.1.4-.1.8,0,1.1.2.3.5.6.8.7.4.1.8.1,1.1,0c.3-.2.6-.4.7-.8s.1-.8,0-1.1c-.2-.3-.5-.6-.8-.7-.4-.1-.8-.1-1.1,0-.3.2-.6.5-.7.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2155,744q0,.2,0,.4.1.3.1.5.1.7.3,1.4.1.8.3,1.5l.1.3v.2l.1.1v.2c0,0,.1.3.2.6.1.4.2.8.3,1.1q.1.3.2.7.1.3.2.7.2.7.6,1.3.4.7.9,1.3c.5.7,1.3,1.2,2.1,1.5.7.4,1.6.7,2.5,1q.2.1.4.1.1.1.4.2.2,0,.4.1.2,0,.4.1.4.1.9.2.5.2,1,.3.1,0,.1,0q.1,0,.2,0q.4.1.7.1.4.1.8.1.5.1.9.1.5,0,.9,0q.2,0,.4,0t.4,0q1.5-.1,2.9-.5q1.4-.5,2.5-1.4.4-.4.7-.8t.5-.8q.1-.2.2-.5t.2-.7c.4-1.9.2-3.6-.5-5.2s-1.8-3-3.2-4.1q-1.3-1.1-2.8-1.9-1.6-.7-3.2-1.3c-1.7-.7-3.5-1.2-5.4-1.4-1.8-.1-3.7.1-5.4.8q-.6.2-1.1.5t-.9.8c-.3.4-.5.8-.5,1.2s.1.8.2,1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2155.2,744.1q0,.1,0,.2-.1,0-.1.1c-.1.5,0,1.1.1,1.7.2.6.4,1.2.5,1.7l.1.4.1.4q.9,0,1.7.1.9,0,1.7.1q2.2.1,4.4.3q2.2.3,4.5.7q1,.2,2,.4q1,.3,1.9.6q1.5.4,2.9,1.1q1.4.6,2.8,1.5c0,0,.1-.2.2-.7c0-.5.1-1.3.1-2.4q-.1-.7-.3-1.4-.3-.6-.7-1.2c-.6-.8-1.3-1.4-2-2-.8-.6-1.6-1.1-2.4-1.5-1.9-1-3.8-1.8-5.8-2.3s-4-.7-6.1-.6q-.9,0-1.9.2-.9.2-1.7.7c-.4.2-.8.4-1.1.8-.4.3-.7.7-.9,1.1Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2170.4,758.1c.6-.8,1.1-1.8,1.4-2.8s.4-2.1.3-3.2q0-.3-.1-.6t-.2-.6q-.1-.5-.2-.8-.2-.4-.4-.8-.1-.3-.2-.4-.1-.2-.2-.4-.4-.6-.8-1-.4-.5-.8-.8-.2-.2-.4-.4-.1-.1-.3-.2-.4-.3-.7-.5-.2-.1-.5-.2-.4-.2-.7-.4-.4-.1-.8-.2-.5-.2-.9-.3-.4,0-.8,0-.5-.1-1-.1-.4,0-.9,0c-1.2.2-2.5.6-3.5,1.2-1.1.6-2,1.4-2.8,2.4h-.1v.1c.1.5.3,1.2.5,1.9s.4,1.4.5,1.8q.2.4.4.9.2.4.4.8c.2.2.3.3.5.4.1.1.3.2.5.3q.4.5.9.8.6.4,1.3.7.3.2.7.3.3.1.6.2l1.2.4l1.2.4c.3.1.6.3.9.4.3.2.6.3,1,.4q.5.1,1,.1.4.1.8.1c.5.1.9.1,1.2.1.4.1.7,0,1,0Z",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2155.7,747.8l.1.4.1.4q.9,0,1.7.1.9,0,1.7.1q2.2.1,4.4.3q2.2.3,4.4.7h.1q1,.2,2,.4q1,.3,1.9.6-.1-.5-.3-.9t-.4-.8q0-.2-.2-.4-.1-.2-.2-.4-.3-.5-.7-1-.5-.5-.9-.8-.2-.2-.4-.4-.2-.1-.4-.3-.3-.2-.6-.4t-.6-.3q-.3-.2-.7-.4-.4-.1-.9-.2-.4-.1-.8-.2-.5-.1-.9-.1-.5-.1-1-.1-.4,0-.9,0c-1.4.2-2.7.6-3.8,1.3-1.1.6-2,1.4-2.7,2.4Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2155.7,747.8l.1.3.1.3q0,0,.1-.2.2-.2.5-.5c.6-.7,1.4-1.4,2.4-1.9c1-.6,2.2-1,3.3-1.1q.5,0,.9,0q.5,0,.9,0q.8.1,1.5.3.6.2,1.3.5t1.3.7t1.1.9q.2.2.4.3.1.2.3.4.7.7,1.1,1.7.5.9.7,2q.2.8.1,1.6q0,.8-.1,1.6-.1.7-.4,1.4t-.7,1.3q-.1.2-.2.4-.1.1-.3.4c0,0,.1-.1.3-.1.1,0,.3,0,.4,0q.2-.2.3-.5.2-.2.3-.5.5-.9.8-1.9.2-1,.2-2.1q0-.6-.1-1.3t-.3-1.3q0-.2-.1-.4q0-.2-.1-.4-.1-.1-.1-.2-.1-.2-.1-.3-.5-.9-1.2-1.7-.6-.8-1.5-1.5-.6-.4-1.3-.8-.6-.4-1.4-.6-.5-.2-1-.3-.6-.1-1.1-.1-.5-.1-1-.1-.4,0-.9,0c-1.4.2-2.7.6-3.8,1.3-1.1.6-2,1.4-2.7,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2157.2,752.8c.3.6.7,1.1,1,1.4.3.4.6.7.8.8q.5.4,1.1.7t1.2.6q.4.1.8.2t.8.3q.2.1.4.1.1.1.4.2.2,0,.4.1.2,0,.4.1.4.1.9.2.5.2,1,.3.1,0,.1,0q.1,0,.2,0c.9-.6,1.6-1.4,2-2.3s.6-1.9.5-3q0-.7-.3-1.4t-.8-1.3c-.6-.8-1.4-1.5-2.4-1.9-.9-.5-2-.6-3.1-.5q-1,.1-1.8.4-.8.4-1.5,1-.2.2-.5.4-.2.2-.4.5t-.4.5q-.2.3-.3.6-.2.4-.3.7t-.1.6q-.1.2-.1.4q0,.1,0,.3Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2154.9,743q0,.3,0,.6t0,.6q0,.1,0,.2t0,.2c.3.5.7.6,1.2.6.5-.1,1-.3,1.4-.3q.8-.1,1.6-.2.8,0,1.6,0q1.6-.1,3.2,0t3.1.4c1.8.3,3.5.6,5.2,1.1c1.6.6,3.2,1.3,4.5,2.5.1.1.4.3.7.5s.6.4.6.5c0,0,0-.1,0-.2c0-.2-.1-.5-.3-1.1-.3-1.2-.8-2.4-1.5-3.5s-1.4-2.1-2.2-3c-1.7-1.9-4.1-3.2-6.7-4-2.6-.7-5.5-1-8.1-.9-.9.1-1.8.3-2.5.7-.8.4-1.3,1-1.5,2q-.2.8-.2,1.6-.1.8-.1,1.7Z",
    fill: "url(#eCqFtfLiQTu89-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2178,749.6q-.5-.2-.9-.5-.5-.2-1-.4-.4-.2-.9-.5-.5-.2-1-.4-.8-.3-1.7-.6-.8-.3-1.7-.5c-1.9-.3-3.6-.5-5.3-.6-1.8,0-3.4,0-5.2,0q-1.1.1-2.2,0-1.1,0-2.1-.3-.4-.1-.7-.3t-.6-.4q-.2-.2-.3-.5-.2-.2-.3-.5-.2-.3-.4-.6t-.3-.7q-.1-.2-.2-.3q0-.2-.1-.4c0-.1,0-.2,0-.4-.1-.1-.1-.3-.1-.3q.5.4,1.2.5.6.2,1.3.3c1.3.2,2.7.4,4,.5c1.4.1,2.8.2,4.1.3q1.6.2,3.1.5q1.5.2,3,.7q1.4.5,2.8,1.1q1.3.6,2.6,1.4.7.4,1.2,1q.6.5,1.2,1.1c.1.2.2.3.3.5s.2.3.2.3Z",
    fill: "#020102"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2166.7,748.8c-.2.3-.1.7,0,1s.4.6.8.7c.3.2.7.2,1,0c.4-.1.6-.4.8-.8.1-.3.1-.7-.1-1-.1-.4-.4-.6-.7-.8-.4-.1-.8-.1-1.1.1-.3.1-.6.4-.7.8Z",
    transform: "translate(0 0.000001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2263.9,613.6c-2.9,1-5,1.9-6.8,3.1s-3.3,2.7-4.9,4.6c-1.5,1.9-2.9,4-3.8,6.3s-1.4,4.7-1.2,7.2c.1-1.1.7-2.3,1.3-3.5.7-1.1,1.4-2.2,1.9-3.2q.9-1.6,1.9-3q1-1.5,2.1-2.9c1.4-1.9,2.7-3.5,4.3-4.9c1.5-1.4,3.2-2.6,5.2-3.7Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2261.9,920.3c-6.1.7-11.9,1.1-17.8,1.1-5.8-.1-11.6-.7-17.8-2-6.3-1.3-12-3.2-17.6-5.5-5.7-2.2-11.2-4.9-17-7.7-5.6-2.7-11-5.1-16.6-5.9-5.6-.9-11.3-.3-17.3,2.9-6.4,3.3-11.4,7.3-15.3,12.1-3.9,4.9-6.7,10.7-8.9,17.6-1.8,6.1-3.4,12.7-3.4,19.1s1.5,12.7,5.8,18.1c3.6,4.4,10.1,6.6,17,7.8c6.9,1.3,14.2,1.8,19.5,2.9c6.5,1.4,12.9,3.1,19.3,4.8c6.4,1.8,12.8,3.7,19.2,5.6c6.3,1.9,13,4.4,19.4,5c6.5.5,12.6-.8,17.8-6.4c2.1-2.2,3.7-5.1,5.1-8.1c1.4-2.9,2.6-6.1,3.8-8.9c1.3-3.1,2.7-6.2,4.1-9.4c1.4-3.1,2.7-6.3,3.8-9.5c1.2-3.6,3.7-10.3,4.9-16.8c1.2-6.4,1.1-12.8-2.9-15.6-1-.8-2.1-1.1-3.1-1.2-.9-.1-1.7,0-2,0Z",
    fill: "url(#eCqFtfLiQTu95-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2229.8,890c-4.1-.5-8.1-1.4-12-2.8-3.9-1.3-7.7-3-11.1-5-1.9-1-3.7-2.3-5.4-3.7s-3.4-2.9-4.8-4.5c-.6-.7-1.3-1.2-1.9-1.8-.7-.6-1.3-1.2-1.9-1.8q-.5-.5-.9-.9-.4-.5-.9-.8-.5-.4-1.1-.7-.5-.2-1.2-.2t-1.3.3q-.7.2-1.2.6-.7.4-1.3.9-.5.5-.9,1.2c-.3.6-.5,1.3-.5,1.9c0,.7,0,1.4.2,2.1.5,2.5,1.7,4.6,3.2,6.6s3.3,3.7,5.1,5.4c3.6,3.3,8.2,5.8,13.1,7.7s10.1,3.1,14.9,3.6c4.2.5,8.9.5,13.2-.6c4.3-1.2,8-3.5,10.5-7.7q-3.4.6-6.9.6-3.4,0-6.9-.4Z",
    fill: "url(#eCqFtfLiQTu96-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2186.6,885.8q.1.2.4.5.2.3.5.6q1.8,2.1,3.9,3.9t4.4,3.3q2.3,1.6,4.8,2.9q2.5,1.2,5,2.3q1.3.5,2.7,1q1.3.5,2.6.9c.9.2,1.8.5,2.7.8.8.3,1.8.5,2.6.6h.2.1c3.8.9,7.7,1.4,11.5,1.7c3.9.3,7.8.3,11.8.1.8-.1,1.6-.2,2.5-.3.8-.1,1.7-.2,2.5-.3c1.6-.1,3.1-.3,4.6-.6s2.9-.6,4.4-1q4-.9,7.6-2.4q3.6-1.4,7.1-3.5c1.6-.9,3-1.9,4.5-3c1.5-1,3-2.1,4.5-3.1q2.4-1.6,4.8-3.3q2.3-1.8,4.5-3.7q1.4-1.1,2.8-2.4q1.3-1.2,2.6-2.5c.3-.3.9-.8,1.4-1.2.5-.5,1-1,1.1-1.4s.1-1.1-.3-2.2c-.5-1.1-1.5-2.6-3.5-4.7-1.2-1.2-2.9-2.5-4.7-3.7s-3.7-2.2-5.2-2.8c.3.4-.6,2-1.7,3.5-1,1.6-2.2,3-2.4,3.3-1.1,1.2-2.3,2.3-3.6,3.4-1.2,1.1-2.6,2.1-3.8,3.2-.1.1-.2.4-.3.7-.1.4-.2.7-.2.9q-.2.5-.3.9-.2.5-.4,1-.3.9-.7,1.8-.3.9-.8,1.7-.9,1.7-1.9,3.3-1.1,1.6-2.3,3c-1.8,2.1-3.5,3.8-5.4,5.3s-4,2.6-6.5,3.6q-2.7,1.1-5.5,1.9-2.7.8-5.6,1.4-5.4,1-10.8,1.1-5.5.1-10.9-.7-1.4-.2-2.7-.4-1.3-.3-2.6-.7-3.4-.8-6.8-2-3.4-1.3-6.5-3c-2.3-1.3-4.5-2.8-6.7-4.5-2.1-1.6-4.1-3.4-6-5.2Z",
    fill: "url(#eCqFtfLiQTu97-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2293.4,724.9c-.3-3.2-2.6-4.7-5.3-5s-5.8.7-7.7,2.4c-.5.4-1.1.9-1.7,1.4-.5.6-1,1.1-1.3,1.8-.3.6-.6,1.3-.6,2c.1.7.4,1.3,1.2,1.5.6.2,1.3.1,2.1-.1.7-.2,1.5-.4,2.1-.4q1.2-.1,2.5,0q1.2.1,2.4.3c.8.1,1.5.2,2.1.1.7-.1,1.4-.3,2.1-.7.6-.4,1.2-.9,1.6-1.5.5-.6.7-1.2.5-1.8Z",
    fill: "url(#eCqFtfLiQTu98-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2273.3,739.3c.7-.9,1.5-1.8,2.5-2.4.9-.6,1.9-1,3-1c.9-.4,1.9-.2,2.8.3s1.7,1.2,2.3,1.9s1.1,1.7,1.4,2.7.5,2.1.4,3.1c0,.7-.1,1.8-.4,2.9s-.8,2-1.6,2.4c1.4-.5,2.7-1.4,3.8-2.6c1-1.1,1.9-2.5,2.5-3.8.5-1,.8-2.2.8-3.4c0-1.1-.2-2.3-.6-3.5-.4-1.3-1.2-2.4-2.3-3.1-1-.7-2.4-1.1-3.8-1.1-2-.1-4,.5-5.6,1.5-1.7,1-3.1,2.5-4.2,4.2q-.1.1-.2.3-.1.1-.1.3-.2.3-.3.6-.2.4-.4.7Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2225.7,631.6q.1.4.1.8-.1.4-.5.9c-.5.7-.9,1.3-1.4,1.9s-1.1,1.2-1.7,1.7c-1.2.9-2.5,1.6-3.8,2.2-1.3.7-2.6,1.2-4,1.8-.6.3-1.3.5-1.9.7-.7.2-1.3.3-2,.3-.6,0-1.2-.2-1.7-.4-.6-.2-1.1-.4-1.6-.6-2.5-.9-5-1.7-7.5-2.4-2.5-.8-5-1.4-7.5-1.9-2.6-.4-5.2-.7-7.8-.7s-5.2.2-7.7.9c4-.4,8.1,0,12,.9s7.7,2.5,11.1,4.5q.4.3.8.6t.6.7c.6,1.4-.9,2.2-2.7,2.5-1.8.4-3.9.4-4.6.3-1.6-.1-3.1-.4-4.6-.8-1.6-.4-3.1-.9-4.6-1.2-4.4-1.2-8.8-2.1-13.2-2.8-4.4-.6-8.8-1-13.3-.9.3,0,.7-.2,1.1-.4s.8-.5,1.1-.6q.7-.3,1.4-.6t1.4-.6q1.4-.5,2.9-1q1.4-.4,2.8-.9c3.2-.8,6.5-1.5,9.7-2.2s6.5-1.2,9.8-1.6q-3.2-.4-6.5-.3-3.3,0-6.5.4-1.7.2-3.3.5-1.7.2-3.3.5-.4,0-.8.1-.5.1-.9.1c-.2.1-.4.2-.7.2-.3.1-.6.2-.7.1-.4-.1-.4-.3-.2-.5.1-.2.4-.4.6-.5q.7-.5,1.4-.9t1.4-.8q1.4-.7,2.9-1.3t3-1.1q1.7-.6,3.5-1q1.8-.5,3.6-.9c3.7-.8,7.3-1.5,10.9-1.9c3.7-.4,7.4-.5,11.1-.1q5.3.5,10.4,1.8t9.9,3.4q.5.3.9.5.4.3.6.6Z",
    fill: "url(#eCqFtfLiQTu101-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2215.7,752.7c0,0,.2.1.4.3.3.1.6.3.8.4c1.4.5,2.6.9,3.7,1.1c1.2.2,2.4.3,3.9.2c1.4-.1,3-.2,4.5-.3c1.6-.2,3.1-.5,4.5-.9c1.1-.3,2.1-.9,2.9-1.6.9-.8,1.6-1.7,2.3-2.7-1.1.7-2.4,1.1-3.4,1.5s-1.9.6-2.4.7q-2.7.8-5.5,1.1-2.7.4-5.5.4-1.4,0-2.8,0-1.3-.1-2.6-.2-.2,0-.3,0-.2,0-.5,0Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830.8,1448.4c-.1.8-.3,1.6-.6,2.3-.3.8-.7,1.4-1.3,1.9q-.7.6-1.5.9t-1.7.4c-6.8,1.5-13.7,2.5-20.7,2.8-6.9.4-13.9.2-20.9-.5-1.4-.1-2.8-.3-4.1-.6-1.4-.3-2.7-.7-3.9-1.4s-2.3-1.8-3.1-3-1.2-2.6-1-3.9l-.3-10.3-.4-10.3q3.4,0,6.8-.4q3.4-.3,6.7-1.1c5.2-.9,10.2-2.6,15-4.7c4.8-2.2,9.3-4.9,13.4-8c.6.7,1.6,1.2,2.6,1.6s2.1.6,3,.8c.6.1,1.2.2,1.9.4.8.2,1.5.4,2.1.5q.2.1.3.1t.3,0q.2.1.4.1.3.1.6.1q1.3.2,2.7.3q1.4.2,2.8.2.2,0,.4.1.1,0,.3,0q0,.2-.1.3q0,.1-.1.3-.7,2.3-1,4.7-.4,2.5-.4,4.9c0,3.7.6,7.2,1.2,10.7.6,3.6,1.1,7.1.6,10.8Z",
    fill: "url(#eCqFtfLiQTu103-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2197.8,879.6c-2-.4-3.5-2.4-5-4.2-1.5-1.9-3-3.6-4.9-3.5-1.4.1-1.6,1.1-1.3,2.3s.9,2.5,1.3,3.1c.7,1,1.6,2.1,2.6,3c1.1,1,2.2,1.7,3.4,2.1c1.7.5,2.9.2,3.6-.5s.8-1.6.3-2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830.8,1448.4c-.1.8-.3,1.6-.6,2.3-.3.8-.7,1.4-1.3,1.9q-.7.6-1.5.9t-1.7.4c-6.8,1.5-13.7,2.5-20.7,2.8-6.9.4-13.9.2-20.9-.5-1.4-.1-2.8-.3-4.1-.6-1.4-.3-2.7-.7-3.9-1.4s-2.3-1.8-3.1-3-1.2-2.6-1-3.9l-.3-10.3-.4-10.3q3.4,0,6.8-.4q3.4-.3,6.7-1.1q0,.1,0,.2t.1.1c.8,2.1,2,4.1,3.5,5.9c1.5,1.7,3.3,3.2,5.3,4.4c2.4,1.3,5,2.2,7.8,2.6c2.7.4,5.5.3,8.2-.4c1.1-.3,2.2-.7,3.2-1.2s2-1.1,2.8-2c.8-.7,1.5-1.6,2-2.6.6-1,1.1-2,1.5-3.1q1.3-3.2,2.2-6.5t1.4-6.7v-.1q.2.1.3.1t.3,0q.2.1.4.1.3.1.6.1q1.3.2,2.7.3q1.4.2,2.8.2.2,0,.4.1.1,0,.3,0q0,.2-.1.3q0,.1-.1.3-.7,2.3-1,4.7-.4,2.5-.4,4.9c0,3.7.6,7.2,1.2,10.7.6,3.6,1.1,7.1.6,10.8Z",
    opacity: 0.6,
    fill: "url(#eCqFtfLiQTu105-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2173.1,757.8c-1.2.2-2.6.2-3.9.1s-2.7-.3-3.9-.5c-1.3-.3-2.7-.7-4-1.3s-2.6-1.4-3.5-2.3q.6.9,1.3,1.7t1.5,1.5c.6.4,1.3.7,2,1c.7.2,1.5.3,2.1.4.8.1,1.6.2,2.5.3.8,0,1.6,0,2.4-.1.6-.1,1.2-.2,1.7-.4.6-.1,1.2-.3,1.8-.4Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2134.1,1138.4v1.1v1.2c-.3,9.3-3.7,18.1-9,25.8-5.4,7.7-12.6,14.3-20.5,19.2s-16.6,8.4-25.5,11.2-18.2,4.8-27.3,6.7c-22.3,4.6-44.8,8.8-67.4,11.2-22.5,2.3-45.2,2.9-67.8.5q-.1,0-.1,0-.1,0-.2.1-.1,0-.1.1-.1,0-.2.2-.1,0-.2.2-.1.1-.2.3-.1.1-.2.3t-.2.4q-.2.3-.3.5-.1.3-.2.5-.3.5-.6,1.1-.3.5-.6,1.1-.1.4-.3.8-.1.3-.3.7t-.4.9-.4.9q-.6,1.4-1.2,2.9t-1.4,3.1q0,.1-.1.3q0,.2-.1.3-.9,2.3-1.8,4.6-1,2.4-1.9,4.7-.4.8-.6,1.5-.3.7-.6,1.4-.5,1.5-1.1,2.9-.5,1.4-1,2.6v.1h-.1q-.7,2-1.4,3.7-.7,1.8-1.2,3.2-.4,1-.7,1.8t-.6,1.5q-.2.3-.2.5-.1.3-.2.5q0,.1-.1.3q0,.1-.1.2-4.9,11.6-9.9,23.3-4.9,11.6-9.9,23.2-4.4,10.3-8.7,20.5-4.4,10.3-8.8,20.6-.9,2.2-1.9,4.4-.9,2.2-1.9,4.4-.1.5-.3.9t-.4.9q-2.7,6.2-5.3,12.5-2.7,6.3-5.4,12.5-1.8,4.1-3.4,8-1.7,4-3.3,8c-1,2.6-1.9,5.4-2.8,8.1s-1.9,5.3-3.1,7.9q-.2.3-.4.6t-.5.5q-.4.3-.8.3-.5.1-.9,0-2.7-.1-5.3-.5-2.6-.3-5.2-.8c-1-.2-2.3-.5-3.5-.9-1.1-.5-2.2-1.2-2.5-2.4q-.1-.4-.1-.8-.1-.4,0-.9.1-7.2.4-14.4.2-7.2.5-14.4.3-6.6.6-13.3.3-6.6.7-13.3q1-18.1,2.3-36.2t2.8-36.2q1.5-17.7,3.3-35.3t3.9-35.2c1.1-9.1,1.4-18.9,3.1-28.1c1.8-9.3,5-18.1,11.9-25.3q2.5-2.7,5.2-4.8q2.6-2,5.4-3.5c2.3-1.3,4.6-2.3,7.1-3.2s5.1-1.7,8-2.4q.7-.1,1.4-.3.8-.2,1.5-.4q2.3-.5,4.5-1t4.4-1q3.6-.8,7.1-1.6t7-1.6q12.3-2.8,24.6-5.4q12.4-2.7,24.7-5.2.1,0,.2,0q.1-.1.2-.1q3.5-.7,7-1.3q3.6-.7,7.1-1.4q4.1-.8,8.2-1.6q4.1-.7,8.2-1.5q2.8-.5,5.6-1q2.7-.5,5.5-.9q11.4-2,22.9-3.7q11.4-1.8,22.9-3.3q3.5-.4,7.1-.8q3.5-.4,7.1-.8q14.7-1.6,29.4-2.8q14.7-1.1,29.5-1.6c4.7-.2,8.7-.3,12.2.6s6.5,2.8,9.2,6.5q.2.3.3.5.2.3.4.5c2.3,3.5,4.1,7.2,5.3,11.2c1.3,3.9,1.9,8,2,12.2Z",
    fill: "url(#eCqFtfLiQTu107-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2134.1,1138.4v.4.3q0,.4,0,.8-.1.4-.1.7c-.3,9.3-3.7,18.1-9,25.8s-12.5,14.3-20.5,19.2c-7.9,4.9-16.5,8.5-25.5,11.2-8.9,2.8-18.1,4.8-27.3,6.7-22.2,4.7-44.7,8.8-67.3,11.2s-45.3,3-67.9.5q0,0-.1,0-.1.1-.1.2-.1,0-.1.1-.1,0-.2.2-.1,0-.2.2-.1.1-.2.3-.1.1-.2.3t-.2.4q-.2.3-.3.5-.1.3-.2.5-.3.5-.6,1.1-.3.5-.6,1.1-.1.4-.3.8-.1.3-.3.7t-.4.9-.4.9q-.7,1.4-1.3,2.9-.6,1.4-1.3,3.1q0,.1-.1.3q0,.2-.1.3-.9,2.3-1.9,4.6-.9,2.3-1.8,4.7-.4.8-.6,1.5-.3.7-.6,1.4-.5,1.5-1.1,2.8-.5,1.4-1,2.7v.1h-.1q-.8,2-1.4,3.7-.7,1.7-1.2,3.2-.4,1-.7,1.8t-.6,1.5q-.2.3-.2.5-.1.3-.2.5-.1.1-.1.2-.1.2-.1.3-5,11.6-10,23.2-4.9,11.6-9.9,23.2-4.3,10.3-8.7,20.6-4.4,10.2-8.7,20.5-1,2.2-1.9,4.5-1,2.2-1.9,4.4-.1.5-.3.9t-.4.9q-2.6,6.3-5.1,12.6-2.6,6.3-5.3,12.5-1.7,4-3.4,7.9-1.7,4-3.3,8c-1,2.6-1.9,5.6-3,8.5-1,2.9-2,5.8-3.3,8.3q-.1.4-.3.7-.2.2-.5.5-.4.2-.8.3-.5,0-.9-.1-1.4,0-2.8-.2-1.4-.1-2.8-.3-.2,0-.5-.1-.3,0-.5-.1c-.6,0-1.5-.2-2.3-.5-.8-.2-1.6-.4-2.3-.5-.9-.2-2.3-.5-3.4-1-1.2-.4-2.2-1.1-2.6-2.3q-.1-.4-.1-.8t0-.9c.1-4.8.2-9.7.4-14.6.1-4.9.3-9.8.5-14.6.2-4.4.6-8.8.9-13.2.4-4.5.8-8.9,1.1-13.4c4.9-4.7,9.2-10.4,13.2-16.5c3.9-6.1,7.4-12.4,10.7-18.2c7.4-13.3,13.4-27.1,18.4-41.4s8.9-28.9,12.1-43.7q1.8-8.5,3.3-17q1.4-8.5,2.6-17c.7-5.1,1.4-10.2,1.6-15.3.1-5.1-.3-10.2-1.9-15.2-1.1-3.4-2.8-6.7-5-9.5-2.2-2.9-4.9-5.3-8-7.1-1.4-.7-2.6-1.5-3.9-2.1-1.4-.6-2.9-1.2-5.2-1.6c2.3-1.3,4.6-2.3,7.1-3.2s5.1-1.7,8-2.4q.7-.1,1.4-.3.8-.2,1.5-.4q2.3-.5,4.5-1t4.4-1c2.4-.5,4.7-1,7.1-1.6c2.3-.5,4.6-1.1,7-1.6q12.3-2.8,24.6-5.4q12.4-2.7,24.7-5.2.1,0,.2,0q.1-.1.2-.1q3.5-.7,7-1.3q3.6-.7,7.1-1.4q4.1-.8,8.2-1.6q4.1-.7,8.2-1.5q2.8-.5,5.6-1q2.7-.5,5.5-.9q11.4-2,22.9-3.7q11.4-1.8,22.9-3.3q3.1-.3,6.3-.7q3.1-.4,6.3-.7.4-.1.8-.1.4-.1.8-.1q14.7-1.6,29.4-2.8q14.7-1.1,29.5-1.6c4.7-.2,8.7-.3,12.2.6s6.5,2.8,9.2,6.5q.2.3.3.5.2.3.4.5c2.3,3.5,4.1,7.2,5.3,11.2c1.3,3.9,1.9,8,2,12.2Z",
    fill: "url(#eCqFtfLiQTu108-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760,1394.9c.8-.9,1.8-1.6,2.9-2.1c1-.5,2.2-.9,3.4-1c.8,0,1.6,0,2.3.2.8.2,1.5.5,2.2.9.6.5,1.1,1.2,1.4,1.9s.4,1.5.3,2.3c-.2.7-.6,1.4-1.1,2-.6.5-1.2,1-1.8,1.4-1.3.9-2.6,1.7-4,2.3s-2.9,1-4.4,1.1q-.6.1-1.3.1-.7-.1-1.3-.4c-.8-.4-1.1-1.1-1.1-1.8-.1-.8.1-1.6.3-2.3q.2-1.3.8-2.5.6-1.1,1.4-2.1Z",
    fill: "url(#eCqFtfLiQTu109-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825.1,1389.9q0,.4-.1.9-.2.4-.4.8c-.7,1.1-1.4,2.1-2.2,3.1-.9,1-1.8,1.9-2.7,2.9-7,7-14.2,13.9-21.9,20.1s-15.9,11.8-24.8,16.2c-.6.2-1.2.5-1.8.8-.7.2-1.3.4-2,.4-1.2,0-2.4-.5-3.5-1.1-1.1-.7-2-1.6-2.9-2.5-3.1-3.3-5.8-7-8.1-10.9s-4.1-8-5.5-12.3q-.3-.9-.6-1.7t-.5-1.7l.3-.8.3-.7q.8-.3,1.5-.5.7-.3,1.4-.5q2.2-.8,4.3-1.5q2.1-.8,4.1-1.6q11.1-4.1,21.9-8.9t21.3-10.3q2.2-1.1,4.4-2.3q2.1-1.2,4.3-2.3.3-.3.7-.4.4-.2.8-.1.4,0,.7.2.3.3.5.5q3,2.6,5.6,5.8q2.5,3.2,4.4,6.7.2.4.3.8.2.4.2.9Z",
    fill: "url(#eCqFtfLiQTu110-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825.1,1389.9q0,.4-.1.9-.2.4-.4.8c-.7,1.1-1.4,2.1-2.2,3.1-.9,1-1.8,1.9-2.7,2.9-7,7-14.2,13.9-21.9,20.1s-15.9,11.8-24.8,16.2c-.6.2-1.2.5-1.8.8-.7.2-1.3.4-2,.4-1.2,0-2.4-.5-3.5-1.1-1.1-.7-2-1.6-2.9-2.5-3.1-3.3-5.8-7-8.1-10.9s-4.1-8-5.5-12.3q.4-1.5,1-3.1.6-1.5,1.4-2.8.2-.3.4-.6.1-.3.3-.6c.7-1.2,1.5-2.6,2.4-3.4c1-.9,2.1-1.2,3.6-.1q.5.4.9.8t.8.8c.9.9,1.6,1.8,2.4,2.7.9.8,1.8,1.6,2.9,2.3c2.2,1.2,4.6,2.2,7.1,2.7s5,.7,7.6.4c4.1-.3,8.1-1.8,11.5-4.2c3.4-2.3,6.2-5.4,8.2-9.1c1-2.2,1.8-4.4,2.4-6.8.5-2.4.8-4.8,1.1-7.2q2.2-1.1,4.4-2.3q2.1-1.2,4.3-2.3.3-.3.7-.4.4-.2.8-.1.4,0,.7.2.3.3.5.5q3,2.6,5.6,5.8q2.5,3.2,4.4,6.7.2.4.3.8.2.4.2.9Z",
    opacity: 0.6,
    fill: "url(#eCqFtfLiQTu111-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.5,1398.3c-.5,1.5-.6,2.9-.6,4.4s.2,2.9.5,4.4q.8,4.4,2.5,8.5q1.6,4.2,4.1,7.9c.3.5.7.8,1,1.1.4.3.8.6,1.2.9s.6.4.7.6.1.4-.1,1c-.3.9-.7,1.8-1.3,2.7-.5.8-1.2,1.6-1.9,2.3-3.2,3.3-7,6-11.2,8-4.1,2-8.7,3.2-13.3,3.6-2.3.2-4.6.2-6.9-.1s-4.5-.8-6.6-1.8c-2.2-.8-4.2-2.1-5.8-3.7-1.7-1.6-3.1-3.5-4-5.6-.6-1.3-.9-2.7-1.1-4.2-.3-1.4-.4-2.9-.4-4.3-.2-2.8-.1-5.7.4-8.4s1.4-5.3,2.8-7.7q.1-.1.2-.3.1-.1.2-.2c1-1.5,2.2-2.9,3.5-4.1c1.3-1.3,2.8-2.4,4.2-3.5c3.6-2.6,7.4-4.9,11.3-7c4-2.1,8-4,12-5.9.7-.4,1.2-.6,1.8-.8s1.2-.4,2.1-.4c.5-.1,1.2,0,1.8,0c.6.1,1.1.1,1.1.1q.4.1.7.3.3.1.7.2q1.7.6,3.4,1.2q1.7.7,3.4,1.3c1.4.5,2.5,1.1,3.6,1.9c1.2.7,2.3,1.7,3.7,3l-2.2.9-2.1.9c0,0-.1-.2-.3-.5-.1-.3-.3-.7-.5-.8q-.3-.3-.7-.5t-.8-.2q-.6-.2-1.3-.1-.6.1-1.2.3c-1.1.4-2,1-2.8,1.8-.7.8-1.3,1.8-1.8,2.8Z",
    fill: "url(#eCqFtfLiQTu112-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.5,1398.3c-.5,1.5-.5,3-.4,4.5.2,1.6.5,3.1.7,4.6.6,2.9,1.3,5.4,2.3,7.9c1,2.4,2.3,4.7,3.9,7.2.3.5.7,1.1,1,1.6.4.6.8,1.1,1.2,1.4s.6.4.7.6.1.4-.1,1c-.3.9-.7,1.8-1.3,2.7-.5.8-1.2,1.6-1.9,2.3-3.2,3.3-7,6-11.2,8-4.1,2-8.7,3.2-13.3,3.6-2.3.2-4.7.3-7.2.1-2.4-.2-4.7-.7-6.9-1.6-2.1-.9-4.1-2.1-5.8-3.7-1.6-1.6-3-3.5-3.9-5.6-.6-1.4-.9-2.8-1.1-4.2-.3-1.4-.4-2.9-.5-4.4-.1-2.7.2-5.7.8-8.5s1.6-5.5,3-7.9q.1-.1.2-.3.1-.1.2-.2c1.8,2.3,3.7,4.1,6,5.6c2.2,1.4,4.8,2.4,7.8,2.9c3.5.6,6.9.6,10.4.3c3.5-.4,7-1,10.4-1.7-2.8-4.4-3.7-9.7-3.1-14.8.6-5.2,2.8-10.2,6.3-13.9.2.1.8.2,1.3.3s1.1.3,1.3.4c1.1.3,2,.6,3,.9c1,.4,2,.8,3.3,1.4c1.3.7,2.3,1.2,3.2,2c1,.7,2,1.6,3.4,2.9l-2.2.9-2.1.9c0,0-.1-.2-.3-.5-.1-.3-.3-.7-.5-.8q-.3-.3-.7-.5t-.8-.2q-.6-.2-1.3-.1-.6.1-1.2.3c-1.1.4-2,1-2.8,1.8-.7.8-1.3,1.8-1.8,2.8Z",
    fill: "url(#eCqFtfLiQTu113-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2300.8,1165.4q0,.1,0,.3q0,.1,0,.2c0,0-.8.2-1.8.4s-2.2.4-3.1.3c-10.5-.7-22,1-33.3,3.9-11.4,2.9-22.5,7-32.1,11-14.8,6.1-29.3,13.6-43,22.5-13.7,8.8-26.6,19-38.2,30.4q-.2.2-.5.5-.2.2-.4.5-5.3,5.3-10.2,10.9t-9.4,11.6c-15.7,1-32.8,1.7-50.4,2.5s-35.7,1.7-53.4,2.8c-1.6.1-3.1.3-4.6.6-1.4.4-2.8,1-4.1,1.9-.9.7-1.8,1.6-2.5,2.6-.7.9-1.3,2-2,3-6.2,10.1-14.1,19-22.9,27s-18.5,15.2-28.3,22c-22.3,15.7-45.6,30-69.6,43.1-24,13-48.7,24.7-74,34.9q-.4-.6-.7-1.3t-.5-1.4q-.2-.3-.3-.5t-.2-.5q-.9-2.1-1.9-4.1-.9-2.1-1.8-4.2-1.3-2.9-2.6-5.8-1.3-3-2.6-5.9q28.1-32.6,56.3-65.2t56.4-65.3c6.2-7.1,12.3-14.2,18.9-20.9s13.5-12.9,21.2-18.3c6.9-4.7,14.2-8.6,21.8-11.9s15.5-5.9,23.5-8.2c7.5-2.1,15.2-3.8,23-5.4s15.6-3,23.4-4.7c6.6-1.3,13.1-2.8,19.4-4.6c6.3-1.7,12.6-3.8,18.6-6.4c14.6-6.3,30.4-10.9,46.5-14.6c16-3.7,32.3-6.5,47.9-9.5c11.9-2.2,23.7-4.2,35.7-5.9c11.9-1.7,23.9-3.1,35.9-4.2c3.7-.3,7.4-.5,11.2-.5c3.7-.1,7.5.1,11.2.5c2.6.4,6.5.8,10,1.8c3.6,1,6.8,2.5,8.2,5.2c2.3,4.4,3.9,9.1,4.8,14s1.1,10,.5,14.9Z",
    fill: "url(#eCqFtfLiQTu114-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2312.6,1166.7c0,0-3.8,0-7.7,0-4,0-8.1,0-9-.1-5.5-.3-11.3,0-17.1.8-5.9.8-12,2.1-17.9,3.7-5.4,1.4-10.7,3-15.8,4.8s-10,3.7-14.6,5.6c-19.5,8.1-38.6,18.6-55.9,31.4s-32.9,27.8-45.8,45c-15.7,1-32.8,1.7-50.4,2.5s-35.7,1.7-53.4,2.8c-1.5.1-3.1.3-4.5.7-1.5.3-2.9.9-4.1,1.8-1,.7-1.8,1.6-2.6,2.6-.7,1-1.3,2-2,3-6.2,10.2-14.1,19-22.9,27s-18.5,15.2-28.3,22c-22.3,15.7-45.5,30.4-69.4,43.8s-48.5,25.5-73.8,35.7c-.9-2-1.9-4.3-2.9-6.7s-2-4.7-2.9-6.7c2.2-.9,4.4-1.8,6.5-2.7s4.1-1.8,5.9-2.8q21-11.4,41.2-24.3q20.2-13,39.3-27.4c7.9-5.9,15.4-12,22.7-18.4c7.3-6.3,14.3-13,21.2-19.8s13.6-13.9,20.3-20.9s13.3-14,20.3-20.8c2.8-2.7,5.6-5.5,8.6-8c3.1-2.5,6.3-4.7,9.9-6.2c2-.8,4.1-1.4,6.2-1.9c2.2-.5,4.3-.9,6.5-1.2c10.6-1.7,21.4-2.3,32.2-3.2s21.5-2.1,32-4.8c3.8-1,7.4-2.5,9.8-4.8c2.5-2.4,3.8-5.6,3.1-9.9-.6-4.3-1.8-7.6-4-10.6-2.3-3.1-5.5-5.8-10-8.9-5.3-3.7-10.9-6.3-16.4-8.5-5.5-2.3-10.8-4.1-15.6-6.1q-.1,0-.2-.2-.1-.1-.1-.3c6.5-1.3,13-2.8,19.3-4.5c6.4-1.8,12.6-3.9,18.6-6.5c14.6-6.3,30.4-10.8,46.5-14.5c16-3.8,32.3-6.6,47.9-9.5c11.9-2.3,23.8-4.3,35.7-6s23.9-3.1,35.9-4.1c3.7-.4,7.5-.6,11.2-.6c3.7-.1,7.5.1,11.2.6c2.6.3,5.8,1.2,9,2.5c3.3,1.2,6.5,2.8,9,4.2q.1.1.1.1.1,0,.1.1c10.7,6.3,15,13.8,16.6,19.7c1.6,6,.5,10.4.5,10.5Z",
    transform: "translate(-4.63301 0)",
    fill: "url(#eCqFtfLiQTu115-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2312.6,1166.7c0,0-3.8,0-7.7,0-4,0-8.1,0-9-.1-5.5-.3-11.3,0-17.1.8-5.9.8-12,2.1-17.9,3.7q-2.2-1.1-4.4-2.1-2.1-1.1-4.2-2.2-6.5-3.2-12.9-6.8-6.4-3.5-12.6-7.2c-1.7-1-3.6-1.8-4.9-2.9-1.3-1-1.9-2.4-1.1-4.6.7-1.7,2-3.2,3.4-4.4c1.5-1.2,3.1-2.2,4.8-2.9c2.4-.9,4.9-1.4,7.4-1.7c2.6-.2,5.2-.2,7.7-.2h14.6h14.5q5.5-.1,11.1-.1q5.5.1,11,.3.1.1.1.1.1,0,.1.1c10.7,6.3,15,13.8,16.6,19.7c1.6,6,.5,10.4.5,10.5Z",
    fill: "url(#eCqFtfLiQTu116-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2100.3,1183.6l76.9-25.1l77-25.2v4.3v4.4l-77,25.5-76.9,25.6-119-37.1-119-37.1-.6-4-.6-4.1l119.6,36.4l119.6,36.4Z",
    transform: "translate(4.63301 0)",
    fill: "url(#eCqFtfLiQTu118-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2254.2,1133.3l-105-20-105-19.9-91.6,8.7-91.5,8.7l119.6,36.4l119.6,36.4l76.9-25.1l77-25.2Z",
    fill: "url(#eCqFtfLiQTu119-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2367.6,1144.9q-.4,1.2-.8,2.4t-.9,2.4c-.9,2.5-2.1,4.9-3.6,6.9-1.5,2.1-3.4,3.8-5.9,4.9-1.3.7-2.8.8-4.3.7-1.6-.1-3.1-.4-4.5-.6-12.6-1.5-25.3-2.6-38-3.4-12.8-.9-25.5-1.7-38.3-2.5q-2.8-.2-5.6-.4t-5.7-.3c-13.2-.9-26.4-1.5-39.6-2.1-13.2-.7-26.4-1.4-39.5-2.4-2.2-.2-4.6-.1-7-.2-2.3,0-4.7-.2-6.7-.7h-.1l-.1-.1c-3.2-.8-6.1-2.3-9-3.7-3-1.3-5.9-2.5-9.3-2.8q-.4-.1-.9-.1-.4,0-.9,0c-2.9,0-5.7.7-8.4,1.5-2.8.8-5.5,1.7-8.3,2.1q-.7,0-1.3.1-.7,0-1.3,0-1,.1-2,0-1,0-2-.1-.5,0-1-.1-.5,0-1-.1-2-.1-3.8-.3-1.9-.2-3.7-.4-.6-.1-1.2-.1-.5-.1-1.1-.1-.5-.1-.9-.2-.5,0-.9-.1-.9-.1-1.9-.2-.9-.1-1.8-.1c-.5,0-.9-.2-1.4-.3-.4-.1-.9-.2-1.4-.2q.1-.1.1-.2.1-.1.1-.2t0-.1q.1,0,.1-.1c.2-.4.5-.9.9-1.3.4-.5.8-.9,1.1-1.3q.9-.9,1.8-1.8t1.8-1.8c4.3-3.8,8.6-7.6,12.9-11.2c4.4-3.6,9-7,13.9-10c1.7-1,3.7-1.7,5.8-1.9c2.1-.3,4.2-.1,6,.7q3.9,1.7,7.8,3.4q3.8,1.6,7.7,3.3c2.3.9,4.5,1.9,6.8,2.8c2.2.8,4.6,1.5,7,1.7c4,.3,8,0,11.9-.6c4-.6,7.9-1.6,11.8-2.5q12.3-2.9,24.5-6t24.4-6.4c7.9-2.1,15.6-4.5,23.4-6.8s15.6-4.4,23.6-6.2c3.4-.7,6.8-1.4,10.1-1.8c3.4-.4,6.8-.6,10.3-.4c3.6.3,7.1.7,10.7,1.4c3.5.7,6.9,1.6,10.3,2.8q3.4,1.2,6.6,2.9q3.2,1.6,6.1,3.7q2.1,1.4,4,3.1q1.9,1.6,3.5,3.5.6.5,1,1.1.5.6,1,1.2c3.1,3.9,5.7,8.8,7.1,14s1.7,10.6,0,15.6Z",
    fill: "url(#eCqFtfLiQTu120-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2367.6,1144.9q-.4,1.2-.8,2.4t-.9,2.4c-.9,2.5-2.1,4.9-3.6,6.9-1.5,2.1-3.4,3.8-5.9,4.9-1.3.7-2.8.8-4.3.7-1.6-.1-3.1-.4-4.5-.6-12.6-1.5-25.3-2.6-38-3.4-12.8-.9-25.5-1.7-38.3-2.5q-2.8-.2-5.6-.4t-5.7-.3c-13.2-.9-26.4-1.5-39.6-2.1-13.2-.7-26.4-1.4-39.5-2.4-2.2-.2-4.6-.1-7-.2-2.3,0-4.7-.2-6.7-.7h-.1l-.1-.1c-3.2-.8-6.1-2.3-9-3.7-3-1.3-5.9-2.5-9.3-2.8q-.4-.1-.9-.1-.4,0-.9,0c-2.9,0-5.7.7-8.4,1.5-2.8.8-5.5,1.7-8.3,2.1q-.7,0-1.3.1-.7,0-1.3,0-1,.1-2,0-1,0-2-.1-.5,0-1-.1-.5,0-1-.1-2-.1-3.8-.3-1.9-.2-3.7-.4-.6-.1-1.2-.1-.5-.1-1.1-.1-.5-.1-.9-.2-.5,0-.9-.1-.9-.1-1.9-.2-.9-.1-1.8-.1c-.5,0-.9-.2-1.4-.3-.4-.1-.9-.2-1.4-.2q.1-.1.1-.2.1-.1.1-.2c1.5-.2,3-.1,4.5-.1c1.6.1,3.3.1,5.1.1c6.9-.3,13.5-2.4,20.2-4.3c6.6-1.9,13.2-3.7,20.2-3.5c4.4.1,8.7,1.1,13,2.2s8.6,2.4,13,3.2c3.7.6,7.6.9,11.5.9c3.8.1,7.7,0,11.5-.2c12.3-.4,24.5-.8,36.7-1.4s24.5-1.4,36.6-2.4c12.7-1.1,25.6-2.6,38-5.4c12.4-2.9,24.3-7.2,35.2-13.9c1.5-1,3.1-2,4.6-3c1.6-1.1,3.1-2.1,4.7-3.1q.6.5,1,1.1.5.6,1,1.2c3.1,3.9,5.7,8.8,7.1,14s1.7,10.6,0,15.6Z",
    fill: "url(#eCqFtfLiQTu121-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1833.6,1451.7q.1,1.2.1,2.5q0,1.2-.1,2.6q0,.9-.1,1.8t-.2,1.8c0,.4-.2.8-.5,1-.3.3-.7.4-1.2.4-17.5-.2-35.1,1.2-52.6,2.2s-35,1.7-52.5.2c-1.1-.1-2.2-.2-3.2-.5-1-.4-2-.9-2.7-1.7-.4-.6-.7-1.3-.9-2s-.2-1.5-.3-2.2c-.2-4,.2-7.9,1.1-11.7s2.2-7.5,4-11q.3-.7.6-1.4.4-.7.7-1.3.4-.8.9-1.5.4-.6.7-1.1.7-1,1.4-1.9.7-.8,1.5-1.6c3.3-3.5,7.4-5.8,12-7.2c4.5-1.5,9.4-2.2,14.1-2.4q4.5-.1,8.9.2t8.8,1q.4.1.9.1.4.1.9.2t1.1.3q.5.1.9.5c.4.2.6.6.8,1s.3.8.5,1.2q1,3.1,1.9,6.3.8,3.2,1.5,6.4.6,2.9,1,5.8.5,2.9.7,5.9c.1.6.3,1.8.6,2.7.2,1,.4,1.8.4,1.8s.9-.1,2-.2c1-.1,2.3-.2,3.2-.3q.1,0,.3-.1.1,0,.2,0q6.2-.8,12.3-1.5q6.2-.6,12.4-1.2c2.6-.2,5.2-.4,7.9-.5c2.6,0,5.3.2,7.9.7q.4.1.9.3.4.1.7.4.2.3.2.8.1.4.1,1c0,.4.1.7.1,1.1c0,.3.1.7.1,1.1Z",
    fill: "url(#eCqFtfLiQTu122-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1833.6,1451.7c.1.8.1,1.6.2,2.4.1.9.1,1.7.1,2.6q0,.9-.1,1.8-.1,1-.3,1.9c0,.4-.3.8-.6,1.1-.4.3-.9.5-1.4.5-17.5-.2-35.1,1.2-52.6,2.3-17.5,1-35,1.8-52.5.2-1-.1-2.2-.2-3.2-.6-1-.3-2-.9-2.6-1.7-.5-.6-.8-1.4-1.1-2.1-.2-.8-.3-1.6-.3-2.3-.3-3.9.2-7.8,1.1-11.7c1-3.8,2.4-7.5,4.2-11q.3-.7.6-1.4.4-.7.7-1.3.4-.8.9-1.5.4-.6.7-1.1.9.8,1.9,1.9.9,1.1,2.1,2.4c4.3,4.8,9.5,8.7,15.2,11.9c5.7,3.1,11.9,5.4,18,7.2c11.2,3.1,22.8,4.6,34.3,4.4c11.6-.2,23.1-2.1,34.2-5.7q.1-.1.2-.1.2-.1.3-.1Z",
    fill: "url(#eCqFtfLiQTu123-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.5,1449.5c.3,0-.2.4-.9.7-.8.4-1.8.8-2.4.9-.7.2-1.4.3-2.1.4-.8.1-1.5.1-2,.1-1.1,0-1.7-.8-2.2-1.8-.4-1.1-.6-2.5-.7-3.6q-.2-2.2-.4-4.4-.3-2.2-.5-4.4-.3-2.6-.8-5.2-.4-2.6-1.2-5.1-.3-1.3-.7-2.6-.5-1.3-1-2.6c0-.2-.3-1.2-.7-2.1-.3-1-.6-1.9-.8-1.9.3,0,.6,0,1-.1.3-.1.7-.1,1-.1q.6.1,1.1.3t.9.5c.4.3.6.6.8,1s.3.8.5,1.2q1,3.1,1.9,6.3.8,3.2,1.5,6.4.6,2.9,1,5.8.5,3,.7,5.9c.1.7.4,1.8.6,2.8.2.9.4,1.7.4,1.7s.8.1,1.9.1c1,0,2.2-.1,3.1-.2Z",
    fill: "url(#eCqFtfLiQTu124-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2142.2,1124.9l-.1.7-.1.7c-3.1-.3-6.2.5-9,1.8s-5.4,3.2-7.6,4.9q-3.7,2.8-7.1,5.9t-6.5,6.5q-.5-.1-.9-.2-.5,0-.9-.1q3.3-3.6,7-6.9q3.6-3.3,7.5-6.3c2.3-1.8,5.1-3.7,8-5.1c3-1.4,6.3-2.2,9.7-1.9Z",
    fill: "#e89477"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2149.4,1133.6l-.1.7v.7q-1.4-.1-2.9-.1-1.4,0-2.7,0c-.9,0-1.7.1-2.6.2s-1.8.3-2.6.6c-.9.3-1.8.7-2.6,1.2s-1.6,1.2-2.6,1.9q-2.4,1.8-4.9,3.8-2.4,1.9-4.8,3.9-.5,0-1-.1-.5,0-1-.1q2.6-2.2,5.4-4.4q2.7-2.1,5.5-4.2c.7-.6,1.6-1.3,2.5-1.9s1.9-1.1,3-1.5c1-.3,1.9-.5,2.9-.6.9-.1,1.8-.2,2.7-.2q1.4,0,2.8,0q1.5,0,3,.1Z",
    fill: "#e89477"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-.077819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2100.3,1183.6l1.6-6.1l1.6-6.2-22.9-114.9-22.9-114.9-114.2-15.9-114.2-16-6.9,2.8-6.8,2.8l142.3,134.2l142.4,134.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2100.3,1183.6l-119.6-36.4-119.6-36.4-17.7-76.2-17.8-76.3-5-21.5-5-21.6l114.3,15.6l114.3,15.6l23.3,98.6l23.3,98.7l4.8,19.9l4.7,20Z",
    fill: "url(#eCqFtfLiQTu132-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2100.3,1183.6l-119.6-36.4-119.6-36.4-17.7-76.2-17.8-76.3c4,10.3,8.6,20.4,13.8,30.1s11.1,19.1,17.7,28.1c18.2,24.6,40.8,45.4,66,62.7s53,31,81.7,41.5c14,5.1,28.2,9.5,42.5,13.3c14.4,3.8,28.9,6.9,43.5,9.7l4.8,19.9l4.7,20Z",
    fill: "url(#eCqFtfLiQTu133-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2008.2,960q2.6.4,5.2.8t5.2.8c2.4.3,4.8.7,7,1.4c2.3.8,4.4,1.8,6,3.5c1.4,1.3,2.3,2.9,3.1,4.7.7,1.7,1.3,3.6,1.8,5.4c4.6,16.5,9.6,34.3,14.4,52.1s9.3,35.7,12.8,52.5c.4,1.7,1.1,5.1.9,7.9-.2,2.7-1.2,4.8-4.4,3.8-2.2-.7-4.1-3.3-5.8-6.2-1.6-2.9-2.9-6-3.8-7.9-7-13.7-15.8-28.4-25.7-42.2s-21-26.6-32.8-36.5c-9.3-7.7-19.6-14.2-30.3-19.7-10.8-5.6-22.1-10.1-33.6-14.1-4.4-1.5-8.8-2.9-13.2-4.7-4.3-1.7-8.5-3.7-12.3-6.3-4.2-2.8-5.3-5.8-4.2-7.9s4.4-3.4,8.9-2.7q25.2,3.8,50.4,7.7q25.2,3.8,50.4,7.6Z",
    fill: "url(#eCqFtfLiQTu134-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2044.2,946.4l6.7-2.5l6.8-2.4l28.5,118.7l28.6,118.7-7.3,2.4-7.2,2.3-28-118.6-28.1-118.6Z",
    fill: "url(#eCqFtfLiQTu135-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953.9,1028.1c4.9,5.6,7.8,12,8.5,17.8.8,5.8-.7,11-4.4,14.3-3.8,3.3-9.2,4-14.8,2.6-5.7-1.5-11.6-5.2-16.5-10.8-4.9-5.5-7.8-11.9-8.5-17.7s.7-11,4.5-14.3c3.7-3.3,9.1-4.1,14.8-2.6c5.6,1.5,11.6,5.2,16.4,10.7Z",
    fill: "url(#eCqFtfLiQTu136-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1958.7,1028.1c4.9,5.6,7.7,12,8.5,17.8.7,5.8-.7,11-4.5,14.3-3.7,3.3-9.1,4-14.8,2.6-5.6-1.5-11.6-5.2-16.5-10.8-4.8-5.5-7.7-11.9-8.5-17.7-.7-5.8.7-11,4.5-14.3s9.1-4.1,14.8-2.6s11.6,5.2,16.5,10.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2003.5,742.7q-.2,0-.4-.1-.2,0-.3-.2-.3-.3-.3-.7t.3-.7l8.6-8.6l8.6-8.6c.2-.2.5-.3.7-.3.3,0,.5.1.7.3q.3.3.3.7t-.3.7l-8.6,8.6-8.6,8.6q-.1.2-.3.2-.2.1-.4.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020.7,742.7q-.2,0-.4-.1-.1,0-.3-.2l-8.6-8.6-8.6-8.6q-.3-.3-.3-.7t.3-.7c.2-.2.4-.3.7-.3s.5.1.7.3l8.6,8.6l8.6,8.6q.3.3.3.7t-.3.7q-.1.2-.3.2-.2.1-.4.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1962.3,798.7c-5,0-9.5-2-12.8-5.3-3.2-3.2-5.2-7.8-5.2-12.7c0-5,2-9.5,5.2-12.8c3.3-3.3,7.8-5.3,12.8-5.3s9.5,2,12.8,5.3c3.2,3.3,5.3,7.8,5.3,12.8c0,4.9-2.1,9.5-5.3,12.7-3.3,3.3-7.8,5.3-12.8,5.3Zm0-34.1c-4.4,0-8.4,1.8-11.3,4.7s-4.7,6.9-4.7,11.4c0,4.4,1.8,8.4,4.7,11.3s6.9,4.7,11.3,4.7s8.4-1.8,11.3-4.7c3-2.9,4.8-6.9,4.8-11.3c0-4.5-1.8-8.5-4.8-11.4-2.9-2.9-6.9-4.7-11.3-4.7Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.384208 0 0 0.315971-46.723583 196.256145)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M210.89,323.07c.5-11,9.83-37.83,27-47.5s29.17-8.33,23,23.5c-3.648014,19.009565-9.812236,37.448422-18.33,54.83-11,0-31.67,1.17-31.67,1.17-.931125-10.646347-.931125-21.353653,0-32Z",
    fill: "#282f36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.06,351.9c6.67-6.67,32.17-12,34.83-8.83s-2,12.83-9.83,12.83c-2.67,0-33.17,3.33-25-4Z",
    fill: "#282f36"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M181.06,323.07c-.5-11-9.83-37.83-27-47.5s-29.17-8.33-23,23.5c3.648014,19.009565,9.812236,37.448422,18.33,54.83c11,0,31.67,1.17,31.67,1.17.931125-10.646347.931125-21.353653,0-32Z",
    fill: "#282f36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.89,351.9c-6.67-6.67-32.17-12-34.83-8.83s2,12.83,9.83,12.83c2.67,0,33.17,3.33,25-4Z",
    fill: "#282f36"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M228.81,171.07c-35.87-23.21-6-23.21-35.87-23.21s-35.62,23.21-35.62,23.21c-4.67,19.33-14.5,54.33-11.5,69.17s13.33,115.5,20.5,115.5c5.12,0,18.7.75,26.75.75s21.63-.75,26.75-.75c7.17,0,17.5-100.67,20.5-115.5s-6.85-49.84-11.51-69.17Z",
    fill: "#282f36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.31,200.73c-.5-2.75,4-6,5.5-8.5s-8.25.5-4.75-2.25s10.25-10.5,8.25-15.75c0,0-3.87-9.87-26.19-9.87s-26.31,9.88-26.31,9.88c-2,5.25,4.75,13,8.25,15.75s-6.25-.25-4.75,2.25s6,5.75,5.5,8.5-11.75,4.5-9.5,17s13.5,12.25,14,30.5c.48,17.4,1,96.86,1.65,108c4,.14,8,.25,11.1.25s7.11-.11,11.1-.25c.69-11.13,1.17-90.6,1.65-108c.5-18.25,11.75-18,14-30.5s-9-14.26-9.5-17.01Z",
    fill: "#e0bf7e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M215.65,87.51c3.3-6.86,35.25-26.71,40.11-22.26s-4.51,46.74-16.49,56C228.33,127,203,107.17,215.65,87.51Z",
    fill: "#282f36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.21,87.51C167.91,80.65,136,60.8,131.1,65.25s4.51,46.74,16.49,56c10.94,5.75,36.29-14.08,23.62-33.74Z",
    fill: "#282f36"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.39,127.07c.33-10.5.67-17.5-7.83-30.17-8.24-12.28-25.72-13.12-38.17-13.16h-.67c-12.45,0-29.93.88-38.17,13.16-8.5,12.67-8.17,19.67-7.83,30.17s-6.67,25-2.83,34.5c3.75,9.3,22.85,19.07,48.83,19.47h.67c26-.41,45.08-10.17,48.83-19.47c3.84-9.5-3.16-24-2.83-34.5Z",
    fill: "#333b45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.22,157c.05-5.26-16.75-11.23-19.75-19.39s6.13-22.61,9.92-30.61c3.57-7.52,2.28-16.44-.09-22.2-5.269966-.739622-10.588899-1.073935-15.91-1h-.67c-5.321101-.073935-10.640034.260378-15.91,1-2.37,5.76-3.66,14.68-.09,22.2c3.79,8,12.92,22.46,9.92,30.62s-19.8,14.13-19.75,19.39c.06,6,4.63,16.4,12.36,23c4.463746.667114,8.967152,1.034603,13.48,1.1h.67c4.512848-.065397,9.016254-.432886,13.48-1.1c7.72-6.63,12.28-17.01,12.34-23.01Z",
    fill: "#f5e4c4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "translate(170.06 130.82)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "translate(216.06 130.82)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M178.75,162.81c3.62,6.33,15.24,4.74,14-4.74",
    fill: "none",
    stroke: "#e0bf7e",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.36,162.84c-3.62,6.33-15.24,4.74-14-4.74",
    fill: "none",
    stroke: "#e0bf7e",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M201.29,150.23c.12-4.19-3.1-3.82-8.23-3.81s-8.36-.38-8.23,3.81s2.87,8.39,8.22,8.6v0c5.37-.2,8.12-4.45,8.24-8.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M185,363.55c3.18-1.75,3-8.69-11.25-13.94-13.2-4.86-19.78-3.07-17,5.75c1.608553,4.954457,6.116711,8.395313,11.32,8.64c3.12.11,15.12.55,16.93-.45Z",
    fill: "#333b45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,231.09c-2.25,9.1,1.75,25.27,6,49s11.75,67.19,12.63,77.8c-.5,5.31,2,6.07,10.5,6.07s10.63,1.77,8.75-22.75c-2.24-29.3-3.16-74.17-4.62-85.38-4.51-34.35-29.51-39.66-33.26-24.74Z",
    fill: "#333b45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M237.06,231.09c2.25,9.1-1.75,25.27-6,49s-11.75,67.19-12.62,77.8c.5,5.31-2,6.07-10.5,6.07s-10.62,1.77-8.75-22.75c2.24-29.3,3.16-74.17,4.63-85.38c4.49-34.35,29.49-39.66,33.24-24.74Z",
    fill: "#333b45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.11,363.55c-3.18-1.75-3-8.69,11.25-13.94c13.2-4.86,19.78-3.07,17,5.75-1.613694,4.967675-6.141798,8.411585-11.36,8.64-3.08.11-15.08.55-16.89-.45Z",
    fill: "#333b45"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.242649 0 0 0.294245 312.48295 198.858604)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.7,303.4l3.8,41.4c1.8,19.6,14.8,30.3,33,30.3h23.1c18.1,0,31.2-10.7,33-30.3l3.8-41.4h-96.7v0Z",
    clipRule: "evenodd",
    fill: "#b4d9d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.9,326.7l1,10.8l1.7,1.7c1.3,1.3,3.6,1.3,4.9,0l11.4-11.4l4.8,4.8c1.4,1.3,3.6,1.3,4.9,0l2.3-2.3l11.6,11.5c1.3,1.4,3.6,1.4,4.9,0l6.7-6.7L205,340c1.4,1.3,3.6,1.3,4.9,0l11.8-11.8l11,11c1.2,1.2,3.2,1.3,4.5.3l1-10.8-3.1,3.1-11-11c-1.3-1.4-3.6-1.4-4.9,0l-11.8,11.8-4.9-4.9c-1.3-1.4-3.6-1.4-4.9,0l-6.7,6.7L179.3,323c-1.4-1.4-3.6-1.4-4.9,0l-2.3,2.3-4.8-4.8c-1.3-1.3-3.6-1.3-4.9,0L151,331.8l-5.1-5.1v0Z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 109.4,
    height: 8.7,
    rx: 0,
    ry: 0,
    transform: "translate(137.4 294.7)",
    clipRule: "evenodd",
    fill: "#90b9b1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.5,219c-37.5-4.4-65.2-14.7-83.2-30.9c70.6-2.1,55.3-32.8-19.1-27.4-12.7-32.3-4-77.6,26.2-135.7c17.5,5.9,32.9,12.3,46.4,19.1-12.7,63.8-1.5,70.9,33.6,21.2c48.5,39.1,47.2,90.3-3.9,153.7v0ZM104.3,109.8c-1.9,3.4,1.9,9.1,8.5,12.8c6.6,3.6,13.4,3.8,15.3.4s-1.9-9.1-8.5-12.8c-6.6-3.6-13.5-3.8-15.3-.4v0ZM201.7,94c-6.3-2.5-15.3,5.4-20.1,17.6-4.7,12.2-3.5,24,2.9,26.5s15.3-5.4,20.1-17.5c4.7-12.2,3.4-24.1-2.9-26.6v0Z",
    clipRule: "evenodd",
    fill: "#417358",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.8,294.7C199,221,144.7,99.8,116.6,45.9c33.6,60.4,88,171,83.4,248.8h-6.2v0Z",
    fill: "#53876b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M164.4,253.2C148,261,134.1,264,122.7,262c28.2-19,14-27.5-14.8-6.2-13.5-9.9-21.6-30.5-24.2-61.8c8.6-2.1,16.5-3.5,23.8-4.2c11.2,29.2,17.6,29.2,19.1,0c29.7,3.4,42.3,24.5,37.8,63.4ZM101.3,231c.1,1.9,3.1,3.2,6.7,3s6.4-1.9,6.3-3.8-3.1-3.2-6.7-3c-3.5.2-6.4,1.9-6.3,3.8Zm35.6-31.5c-3.2.6-4.8,6.1-3.6,12.3s4.8,10.7,8,10c3.2-.6,4.8-6.1,3.7-12.3-1.3-6.1-4.9-10.6-8.1-10v0Z",
    clipRule: "evenodd",
    fill: "#78a668",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.5,294.7c-5.8-44.7-54.8-72.6-90.6-93.7c38.2,17.8,87.7,48.3,93.6,93.7h-3Z",
    fill: "#9c9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M215.1,251.7c29,4.1,51.8,1.8,68.5-6.8-52.6-15.5-35-35.6,19.7-16.7c15.9-21.8,18.3-57.4,7.2-107-14.3,1-27.1,2.7-38.6,5.2-3.1,50.4-12.9,53.4-29.4,9.3-44.1,19.6-53.2,58.3-27.4,116Zm86.2-64.9c.7,2.9-3.2,6.5-8.9,7.9-5.6,1.4-10.8.2-11.6-2.8-.7-2.9,3.2-6.5,8.9-7.9s10.9-.2,11.6,2.8Zm-69.9-31.1c5.3-.6,10.4,7.1,11.6,17.1c1.2,10.1-2.1,18.7-7.4,19.3s-10.4-7.1-11.6-17.1c-1.2-10.1,2.1-18.7,7.4-19.3Z",
    clipRule: "evenodd",
    fill: "#5c8a5c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.3,294.7c-.4-52.3,67.1-134.6,99.1-163.4-30.6,34.2-93.1,111.3-92.4,163.4h-6.7Z",
    fill: "#696"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.342692 0 0 0.375636 190.451696 168.640793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.65,208.8c-11.54,9.89-25.16-2.95-20.32-15.89c4.2-11.25,11.13-19,6.39-23.28s-26,3.71-34,22.87-8.86,31.5-39.56,44.92-85.3,34.58-28.23,99.93s89.63,18.75,96.43-4.95s11.74-35.23,33.17-44.3s29.33-29,19.57-34.82c-6.18-3.71-17.51,13.81-30.49,2.06-2.88-3.3-4.17-9.3,6.41-20.59c10.84-11.57,132.63-138.29,136.13-142.2s13.64,2.49,17.55-.6s16.48-27.2,25.34-36.47c3.3-3.71,11.33-4.74,14.22-7.62s-2.26-16.28-24.92-3.92-44.34,24.93-48.83,28.23s2.58,11-2.48,15.81Z",
    fill: "url(#eCqFtfLiQTu240-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.54,258.91c-20.87,10.43-26.48,21.23-17.17,31.73c8.54,9.64,20.47,8.38,29.95,18.27s10.06,29.91,21.72,39.24c13.19,10.57,25.23-11.36,28.63-30.83c2.59-14.85,8-22.8,25.33-31s24.18-11.71,23-17.71c-2.06-10.1-32,9.33-39.71-16-5.36-17.54-6.59-31.32-15.25-38s-10.89,14.39-23.26,26.72c-8.65,8.67-23.9,12.91-33.24,17.58Z",
    fill: "url(#eCqFtfLiQTu241-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.54,208l-33.22,32.23c-.28278.278214-.442033.658304-.442033,1.055s.159253.776786.442033,1.055l16.41,16.41c.278214.28278.658304.442033,1.055.442033s.776786-.159253,1.055-.442033L192,225.45l121.52-127-12.21-12.22Z",
    fill: "url(#eCqFtfLiQTu242-fill)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.74,
    height: 8.74,
    rx: 1.7,
    ry: 1.7,
    transform: "matrix(.707107 0.707107-.707107 0.707107 133.014474 240.323693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.74,
    height: 8.74,
    rx: 1.7,
    ry: 1.7,
    transform: "matrix(.707107 0.707107-.707107 0.707107 113.448315 259.893693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.74,
    height: 8.74,
    rx: 1.7,
    ry: 1.7,
    transform: "matrix(.707107 0.707107-.707107 0.707107 95.442471 277.883693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 8.16,
    transform: "matrix(.707107-.707107 0.707107 0.707107 128.190852 315.452816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.83,
    transform: "matrix(.707107-.707107 0.707107 0.707107 127.785658 337.077449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "97.66,286.28 319.84,72.09 312.94,55.92",
    fill: "none",
    stroke: "#81858c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "103.02,291.64 330.81,66.47 323.93,49.6",
    fill: "none",
    stroke: "#81858c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "108.38,297 341.97,60.19 334.32,42.89",
    fill: "none",
    stroke: "#81858c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "113.73,302.36 353.13,53.91 347.25,39.13",
    fill: "none",
    stroke: "#81858c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.92,
    height: 7.31,
    rx: 3.65,
    ry: 3.65,
    transform: "matrix(.869926-.493183 0.493183 0.869926 306.558568 55.195029)",
    fill: "url(#eCqFtfLiQTu252-fill)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.92,
    height: 7.31,
    rx: 3.65,
    ry: 3.65,
    transform: "matrix(.869926-.493183 0.493183 0.869926 318.186297 49.261954)",
    fill: "url(#eCqFtfLiQTu253-fill)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.92,
    height: 7.31,
    rx: 3.65,
    ry: 3.65,
    transform: "matrix(.869926-.493183 0.493183 0.869926 329.267773 43.7268)",
    fill: "url(#eCqFtfLiQTu254-fill)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.92,
    height: 7.31,
    rx: 3.65,
    ry: 3.65,
    transform: "matrix(.869926-.493183 0.493183 0.869926 340.647067 37.92881)",
    fill: "url(#eCqFtfLiQTu255-fill)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.59,
    transform: "matrix(.707107-.707107 0.707107 0.707107 319.86929 72.054797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.59,
    transform: "matrix(.707107-.707107 0.707107 0.707107 330.031773 66.314729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.59,
    transform: "matrix(.707107-.707107 0.707107 0.707107 341.515002 60.352786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.59,
    transform: "matrix(.707107-.707107 0.707107 0.707107 352.696896 54.073773)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout12);
export default __webpack_public_path__ + "static/media/about12.f4ee0b061295c14d948c6cebb14d2346.svg";
export { ForwardRef as ReactComponent };